import { combineReducers } from 'redux'
import { browserHistory } from 'utils/navigation'
import {
  getFormulaErrors,
  getMetadataErrors,
  getSchedulingErrors,
  getAllErrors,
  _isInvalid,
  checkForAdvancedDeploymentOptions,
  formatInstrumentValidationNotyMessage,
} from 'utils/instrumentValidation'
import { modalActions } from 'store/modal'
import { loadingActions } from 'store/loader'
import request, { generateNotyMessage } from 'utils/request'
import { getScoreErrors } from 'utils/instrument'
import {
  getFirstIncompleteTimedMatchingGridSequenceWarning,
  hasIncompleteTimedMatchingGridKey,
} from 'utils/timedMatchingGrid'
import { uniqueArr } from 'utils/misc'
import { convertAdvancedOptions } from 'utils/hoc/AdvancedOptionsHOC'
import {
  CLINRO_NON_SP_ROLE_IDS,
  GROUP_TYPE_MAP,
  INSTRUMENT_TYPE_MAP,
  INSTRUMENT_TYPES_WITH_SCHEDULE_PLATFORM,
  coerceSchedulePlatformType,
  SCHEDULE_PLATFORM_TYPE,
  INSTRUMENT_DISPLAY_LOCATION_OPTIONS,
  TRIGGER_TYPE_MAP,
  MODAL_CONTENT_MAP,
  MODAL_BUTTONS_MAP,
  MODAL_CLASSES_MAP,
  TASKS_WITH_AUDIO_PERMISSION,
  TASKS_WITH_STORAGE_PERMISSION,
  MOBILE_APP_PERMISSION_NAMES_MAP,
  USER_ROLE_ID_MAP,
  DEPLOYMENT_KEYS,
} from 'utils/constants'
import moment from 'moment'
import { compareJSON } from 'utils/object'
import { fromEpochToUTC } from 'utils/time'
import { actions as notyActions } from 'layouts/ErrorBox'
import { logSentryEvent } from 'utils/sentry'
import { saveTaskToDB } from '../routes/SelectTask/modules/SelectTask'
import {
  validateArticleAndSave,
  validateSurveyAndSave,
  saveUploadToDatabase as saveSurveyUploadToDatabase,
} from '../routes/EditSurvey/modules/Survey'
import { validateClinroAndSave, saveClinroUploadToDatabase } from '../routes/EditClinro/modules/Clinro'
import { saveUploadToDatabase as saveDiaryUploadToDatabase } from '../routes/EditDiary/modules/Diary'
import { validateConsentAndSave } from '../../../../Consent/routes/ConsentEditor/modules/Consent'
import {
  validateConsentAndSave as newValidateConsentAndSave,
  onCreateNewConsent,
} from '../../../../Consents/routes/ConsentView/routes/NewConsentBuilder/modules/NewConsent'
import { validateDiaryAndSave } from '../routes/EditDiary/modules/Diary'
import { _getDefaultMetadata, _getDefaultSchedule } from '../../../utils/PropertyFields'
import {
  applyScheduleVersions,
  cloneSchedule,
  commitScheduleToList,
  createBlankSchedule,
  ensureScheduleIds,
  getRandomScheduleId,
  getScheduleId,
  hydrateSchedulesFromMetadata,
  keepPersistedScheduleVersions,
} from '../../../utils/multiSchedule'
import {
  applyMetadataVisibilityForSave,
  applyPerScheduleVisibilityForSave,
  DEFAULT_VISIBILITY,
  DEFAULT_VISIBILITY_RANGES,
  hydrateSchedulesWithVisibility,
  usesPerScheduleVisibility,
} from '../../../utils/scheduleVisibility'
import {
  applyReviewSettingsToAllSchedules,
  hydrateSchedulesWithReviewSettings,
  resolveReviewSettingsSourceSchedule,
} from '../../../utils/scheduleReviewSettings'
import { enrichTaskMetadataForSave, flattenTaskMetadata } from '../../../utils/taskInstrumentMetadata'
import {
  applyPersistedMetadataForScheduleSave,
  buildV2InstrumentUpdateBody,
  instrumentV2Urls,
  runInstrumentV2AsyncJob,
} from '../../../utils/instrumentV2Api'
import {
  changeTrigger,
  changeAction,
  saveConditions,
  fetchInstrumentConditions,
} from '../../../../Notifications/routes/EditConditionalNotification/modules/ConditionalNotification'
import { SET_VISIT_TEMPLATES } from '../../../../Participants/routes/CreateParticipant/modules/CreateParticipant'
import { fetchInstruments } from '../../InstrumentsPage/modules/Instruments'
import { _saveAnnouncementToDbAsInstrument } from '../../../../Announcements/routes/EditAnnouncement/modules/Announcement'
import {
  getStudyVersionID,
  hasMultiScheduleFeature,
  isVersionUatOrLive,
} from '../../../../../../../../../utils/studyConfigUtils'

export const RESET_SCHEDULE = 'RESET_SCHEDULE'
export const UPDATE_SCHEDULE = 'UPDATE_SCHEDULE'
export const UPDATE_SCHEDULE_FIELD = 'UPDATE_SCHEDULE_FIELD'
const DELETE_SCHEDULE_FIELD = 'DELETE_SCHEDULE_FIELD'
const DELETE_METADATA_FIELD = 'DELETE_METADATA_FIELD'
const ADD_DIARY_NOTIFICATION_TRIGGER = 'ADD_DIARY_NOTIFICATION_TRIGGER'
const UPDATE_DIARY_NOTIFICATION_TRIGGER = 'UPDATE_DIARY_NOTIFICATION_TRIGGER'
const ADD_INSTRUMENT_TRIGGER = 'ADD_INSTRUMENT_TRIGGER'
const ADD_VISIBILITY_RANGE = 'ADD_VISIBILITY_RANGE'
const CHANGE_INSTRUMENT_TRIGGER_TYPE = 'CHANGE_INSTRUMENT_TRIGGER_TYPE'
const CLEAR_ERRORS = 'CLEAR_ERRORS'
const CLEAR_INSTRUMENT_CONDITIONS_TO_DELETE = 'CLEAR_INSTRUMENT_CONDITIONS_TO_DELETE'
const CLEAR_INSTRUMENT_EVENTS = 'CLEAR_INSTRUMENT_EVENTS'
const CLEAR_INSTRUMENT_TRIGGERS = 'CLEAR_INSTRUMENT_TRIGGERS'
const CLEAR_PREVALIDATED_ERROR = 'CLEAR_PREVALIDATED_ERROR'
const DELETE_INSTRUMENT_TRIGGER = 'DELETE_INSTRUMENT_TRIGGER'
const REMOVE_CHAIN_DEPLOYMENT_INFO = 'REMOVE_CHAIN_DEPLOYMENT_INFO'
const RESET_INSTRUMENT = 'RESET_INSTRUMENT'
const SET_CLINRO_ROLES = 'SET_CLINRO_ROLES'
const SET_ERRORS = 'SET_ERRORS'
const SET_INSTRUMENT = 'SET_INSTRUMENT'
const SET_INSTRUMENT_EVENTS = 'SET_INSTRUMENT_EVENTS'
const SET_INSTRUMENT_TRIGGERS = 'SET_INSTRUMENT_TRIGGERS'
const TOGGLE_SAVE_ATTEMPT = 'TOGGLE_SAVE_ATTEMPT'
const UPDATE_ARTICLE_URL = 'UPDATE_ARTICLE_URL'
const UPDATE_GEOFENCE_ENABLED = 'UPDATE_GEOFENCE_ENABLED'
const UPDATE_INSTRUMENT_ACTION = 'UPOATE_INSTRUMENT_ACTION'
const UPDATE_INSTRUMENT_ROLES = 'UPDATE_INSTRUMENT_ROLES'
const UPDATE_INSTRUMENT_TITLE = 'UPDATE_INSTRUMENT_TITLE'
const UPDATE_INSTRUMENT_DISPLAY_LOCATION = 'UPDATE_INSTRUMENT_DISPLAY_LOCATION'
const UPDATE_INSTRUMENT_TRIGGER = 'UPDATE_INSTRUMENT_TRIGGER'
const UPDATE_METADATA_FIELD = 'UPDATE_METADATA_FIELD'
const UPDATE_PREVALIDATED_ERRORS = 'UPDATE_PREVALIDATED_ERRORS'
const UPDATE_VISIBILITY = 'UPDATE_VISIBILITY'
const UPDATE_VISIBILITY_RANGE = 'UPDATE_VISIBILITY_RANGE'
const SET_ADVANCED_OPTIONS = 'SET_ADVANCED_OPTIONS'
const RESET_ADVANCED_OPTIONS = 'RESET_ADVANCED_OPTIONS'
const SET_INSTRUMENT_UNIFICATION_ENABLED = 'SET_INSTRUMENT_UNIFICATION_ENABLED'
const RESET_INSTRUMENT_UNIFICATION_ENABLED = 'RESET_INSTRUMENT_UNIFICATION_ENABLED'
const SET_CONFIRMED_SCHEDULES = 'SET_CONFIRMED_SCHEDULES'
const SET_PERSISTED_SCHEDULES = 'SET_PERSISTED_SCHEDULES'
const SYNC_PERSISTED_INSTRUMENT = 'SYNC_PERSISTED_INSTRUMENT'
const SET_ACTIVE_SCHEDULE_INDEX = 'SET_ACTIVE_SCHEDULE_INDEX'
const COMMIT_CURRENT_SCHEDULE = 'COMMIT_CURRENT_SCHEDULE'
const DELETE_CONFIRMED_SCHEDULE = 'DELETE_CONFIRMED_SCHEDULE'
const START_NEW_SCHEDULE = 'START_NEW_SCHEDULE'
const LOAD_SCHEDULE_FOR_EDIT = 'LOAD_SCHEDULE_FOR_EDIT'

export const DEFAULT_DEPLOY_TIME = '09:00'

const DEFAULT_PERSISTENT_SCHEME = { scheme: 'persistent' }

export const getLastPathSegment = pathname => {
  const pathMatch = pathname?.match(/([^/]+$)/)
  return pathMatch ? pathMatch[0] : ''
}

const RESERVED_INSTRUMENT_PATH_SEGMENTS = new Set([
  'instruments',
  'selecttask',
  'createinstrument',
  'createclinro',
  'creatediary',
  'uploadinstrument',
  'createarticle',
  'editarticle',
])

export const getRedirectInstrumentID = ({ instrument, resJSON, pathname, path }) => {
  const pathnameSuffix = getLastPathSegment(pathname?.replace(`/${path}`, ''))
  const fallbackId = RESERVED_INSTRUMENT_PATH_SEGMENTS.has(pathnameSuffix) ? undefined : pathnameSuffix
  return instrument?.id || resJSON?.id || fallbackId || undefined
}

/**
 * Properties → Schedule must reopen the schedule editor the user just left
 * (including a new multi-schedule draft). Forcing schedule 0 reloads the first
 * schedule and drops Triggered by Visit on a later schedule.
 * The scheduler route treats this state as "keep the in-memory schedule".
 */
export const getInstrumentScheduleReturnState = (currentPath, redirectPath) => {
  if (currentPath === 'properties' && redirectPath === 'schedule') {
    return { keepTriggerDraft: true }
  }
  return undefined
}

//
// API Actions
//

const _compareInstruments = (current, original) => {
  const _blank = { activeItemId: null, activeItem: null }
  const _current = { ...current, ..._blank }
  const _original = { ...original, ..._blank }
  return compareJSON(_current, _original)
}

// Audience type values that indicate an intentional cohort selection (Schedule tab).
const AUDIENCE_TYPE_VALUES = [
  GROUP_TYPE_MAP.all,
  GROUP_TYPE_MAP.allParticipants,
  GROUP_TYPE_MAP.allCaregivers,
]

// Normalize schedule.cohort coming from API (array of items) into a single object with filters.
// Audience type comes from Schedule tab UI (ParticipantManagement checkboxes) and is stored in
// instrument.metadata.schedule.cohort.type (or audience_type) in the Redux store.
// Older instrument JSON may not have audience_type or it may be null (new field); we treat
// missing/null as absent and derive type from cohort array/object, then default to all_participants.
const normalizeScheduleCohort = (schedule = {}) => {
  const { cohort, audience_type } = schedule
  // Treat null/undefined audience_type the same (legacy instruments)
  const effectiveAudienceType = audience_type ?? undefined
  const normalized = {
    type: effectiveAudienceType,
    filter: {},
  }

  if (Array.isArray(cohort)) {
    cohort.forEach(item => {
      const { type, filter = {} } = item || {}
      if ([GROUP_TYPE_MAP.all, GROUP_TYPE_MAP.allParticipants, GROUP_TYPE_MAP.allCaregivers].includes(type)) {
        // Prefer explicit audience_type if present and valid, otherwise use the audience entry.
        if (effectiveAudienceType == null) normalized.type = type
      } else if (type === GROUP_TYPE_MAP.age) {
        if (filter.min_age !== undefined) normalized.filter.min_age = filter.min_age
        if (filter.max_age !== undefined) normalized.filter.max_age = filter.max_age
      } else if (type === GROUP_TYPE_MAP.cohort && Array.isArray(filter.include)) {
        normalized.filter.include = filter.include
      } else if (type === GROUP_TYPE_MAP.sites && Array.isArray(filter.site_ids)) {
        normalized.filter.site_ids = filter.site_ids
      }
    })
  } else if (cohort && typeof cohort === 'object') {
    // UI/object shape from the Schedule tab. cohort.type is the current selection
    // and must win over a stale schedule.audience_type from a previous save.
    normalized.filter = cohort.filter || {}
    normalized.type = AUDIENCE_TYPE_VALUES.includes(cohort.type)
      ? cohort.type
      : effectiveAudienceType ?? cohort.type
  }

  if (normalized.type == null || normalized.type === '') normalized.type = GROUP_TYPE_MAP.allParticipants

  return normalized
}

// Build the cohort array payload for API based on current cohort object and audience selection.
const buildCohortPayload = (cohortObj = {}) => {
  const { filter = {}, type = GROUP_TYPE_MAP.allParticipants } = cohortObj
  const cohortArray = []

  // Audience node: special case caregivers-only -> type should be all_users per requirement
  const audienceTypeForPayload =
    type === GROUP_TYPE_MAP.allCaregivers ? GROUP_TYPE_MAP.all : type
  cohortArray.push({ type: audienceTypeForPayload, filter: {} })

  const { min_age, max_age, include, site_ids } = filter
  if (min_age !== undefined || max_age !== undefined) {
    cohortArray.push({
      type: GROUP_TYPE_MAP.age,
      filter: {
        min_age,
        max_age,
      },
    })
  }
  if (Array.isArray(include) && include.length > 0) {
    cohortArray.push({
      type: GROUP_TYPE_MAP.cohort,
      filter: { include },
    })
  }
  if (Array.isArray(site_ids) && site_ids.length > 0) {
    cohortArray.push({
      type: GROUP_TYPE_MAP.sites,
      filter: { site_ids },
    })
  }

  return cohortArray
}

// Global save handler for instruments, conditionally saves instruments based on type and handles POST vs PUT/PATCH
// requests
export const onSave = (redirect, showModal, consentProps, queries = {}) => {
  return (dispatch, getState) => {
    const {
      instrumentReducer,
      study,
      location,
      consentReducer,
      newConsentReducer,
      surveyEditor,
      clinroEditor,
      diaryEditor,
      upload,
    } = getState()
    const studyVersionID = getStudyVersionID(location)
    const { studyVersionList } = study
    const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
    const isReadOnlyState = hasStudyPromotion && isVersionUatOrLive(studyVersionList, studyVersionID)

    const { query = '', confirmQuery = '', cancelQuery = '' } = queries
    let queryParams = query

    const studyID = study.currentStudy.id
    const {
      instrument: storeInstrument,
      _instrument,
      instrumentTriggers,
      conditionsToDelete,
      instrumentAdvancedOptions,
    } = instrumentReducer
    const { conditions } = instrumentTriggers
    const hasConditions = !!conditions?.length || !!conditionsToDelete?.length
    // Use instrument from store so Schedule tab (ParticipantManagement) checkbox selection
    // is included; audience type is stored in metadata.schedule.cohort.type / audience_type.
    let instrument = Object.assign({}, storeInstrument)
    const { type } = instrument
    const path = getLastPathSegment(location.pathname)

    const hasAdvancedOptions = checkForAdvancedDeploymentOptions(instrumentAdvancedOptions)
    if (hasAdvancedOptions) {
      const convertedAdvancedOptions = convertAdvancedOptions(instrumentAdvancedOptions)
      if (convertedAdvancedOptions) {
        // UAT shape: cohort array = audience item first, then filter items from convertAdvancedOptions.
        // Audience is set by ParticipantManagement (Schedule tab checkboxes) and stored in the instrument
        // reducer; we read it from the store instrument so payload matches the UI selection.
        const normalizedCohort = normalizeScheduleCohort(instrument.metadata.schedule)
        const audienceType = normalizedCohort.type
        const cohortTypeForPayload =
          audienceType === GROUP_TYPE_MAP.allCaregivers ? GROUP_TYPE_MAP.all : audienceType
        const audienceItem = { type: cohortTypeForPayload, filter: {} }
        instrument = {
          ...instrument,
          metadata: {
            ...instrument.metadata,
            schedule: {
              ...instrument.metadata.schedule,
              audience_type: audienceType,
              cohort: [audienceItem, ...convertedAdvancedOptions],
            },
          },
        }
      }
    }

    let shouldSave = false
    let action
    const isClinro = type === INSTRUMENT_TYPE_MAP.clinro
    const isSurvey = type === INSTRUMENT_TYPE_MAP.survey && !path.includes('consent')
    const isDiary = type === INSTRUMENT_TYPE_MAP.diary

    /**
     * We need to check if survey or clinician instrument changes create new scoring formula errors.
     * If so, we make the redirect path 'scoring' to allow the user to see the errors on the scoring
     * page and warn them to fix the errors.
     */
    const hasNewFormulaErrors =
      (isClinro || isSurvey || isDiary) && !consentProps
        ? !!getFormulaErrors(isClinro ? clinroEditor.clinro : isSurvey ? surveyEditor.survey : diaryEditor.diary).scores
        : false
    const redirectPath = hasNewFormulaErrors ? 'scoring' : redirect

    /**
     * We also need to check for pre-existing score errors, so that even if the user does not save
     * the current state of the instrument, they will be redirected to the scoring page to fix the
     * pre-existing errors.
     */
    const hasScoreErrors =
      (isClinro || isSurvey) && !consentProps ? !!getScoreErrors(isClinro ? clinroEditor : surveyEditor, type) : false
    const nonSavingRedirectPath = hasScoreErrors ? 'scoring' : redirect

    /**
     * A timed matching grid without its symbol key must never slip past the builder, even when the
     * instrument itself is unchanged, so route navigation through validation to surface the error.
     */
    const hasMissingSymbolKey =
      (isSurvey && !consentProps && hasIncompleteTimedMatchingGridKey(surveyEditor.survey?.questions)) ||
      (isClinro && hasIncompleteTimedMatchingGridKey(clinroEditor.clinro?.questions))

    /**
     * Navigation callback upon instrument save
     * @param {Object} resJSON
     * @param {Boolean} noSave
     */
    const onRedirect = (resJSON, noSave = false) => {
      if (resJSON && !resJSON.ok && resJSON.status === 412) return
      // sometimes instrument.id and resJSON?.id are undefined so we are using the id from the pathname
      const instrumentID = getRedirectInstrumentID({ instrument, resJSON, pathname: location.pathname, path })
      const destination = noSave ? nonSavingRedirectPath : redirectPath
      _redirect(
        destination,
        studyID,
        instrumentID,
        consentProps ? { ...newConsentReducer.consent, ...consentProps } : null,
        queryParams,
        studyVersionID,
        getInstrumentScheduleReturnState(path, destination),
      )
    }

    if (redirect === 'e-consent') {
      shouldSave = !_compareInstruments(consentReducer.consent, consentReducer.originalConsent)
      action = () => dispatch(validateConsentAndSave({ studyID, consentReducer, onRedirect }))
    } else if (
      (['consents', 'createconsent', 'schedule', 'formatting'].includes(redirect) && !!consentProps) ||
      (redirect === 'properties' && !!consentProps) ||
      (redirect === 'editconsent' && !!consentProps) ||
      (redirect === 'deploy' && !!consentProps)
    ) {
      const isUpdate = consentProps?.isUpdate
      const isPdfUpload = consentProps?.isPdfUpload
      const setForScheduling = consentProps?.setReadyToBeScheduled
      const { advancedOptions: consentAdvancedOptions, shouldValidate = false } = consentProps
      const convertedAdvancedOptions = convertAdvancedOptions(consentAdvancedOptions)

      shouldSave =
        !_compareInstruments(newConsentReducer.consent, newConsentReducer.originalConsent) ||
        !isUpdate ||
        setForScheduling ||
        !compareJSON(newConsentReducer.consent.metadata.schedule.cohort, convertedAdvancedOptions) ||
        (shouldValidate && !consentAdvancedOptions && Array.isArray(newConsentReducer.consent.metadata.schedule.cohort))

      action = () =>
        isUpdate
          ? dispatch(
            newValidateConsentAndSave({
              studyID,
              newConsentReducer,
              onRedirect,
              isPdfUpload,
              ...consentProps,
            }),
          )
          : dispatch(
            onCreateNewConsent({
              studyID,
              newConsentReducer,
              onRedirect,
              isPdfUpload,
            }),
          )
    } else if (path === 'createarticle' || path === 'editarticle') {
      shouldSave = !compareJSON(instrument, _instrument)
      action = () => dispatch(validateArticleAndSave(studyID, surveyEditor.article, onRedirect))
    } else if (path === 'selecttask') {
      shouldSave = instrument.title !== ''
      action = () => dispatch(saveTaskToDB(studyID, instrument)).then(onRedirect)
    } else if (path === 'properties') {
      shouldSave = !compareJSON(instrument, _instrument)
      action = () =>
        dispatch(
          validateThenSave({
            studyID,
            instrument,
            validationType: path,
            onRedirect,
            syncReviewSettings: queries.syncReviewSettings,
          }),
        )
    } else if (path === 'schedule') {
      if (!hasAdvancedOptions && Array.isArray(instrument.metadata.schedule.cohort)) {
        const normalized = normalizeScheduleCohort(instrument.metadata.schedule)
        instrument.metadata.schedule.cohort = normalized
        if (instrument.metadata.schedule.audience_type != null) {
          instrument.metadata.schedule.audience_type = normalized.type
        }
      }
      shouldSave = hasConditions ? true : !compareJSON(instrument, _instrument)
      action = () =>
        hasConditions
          ? dispatch(validateThenDeploy({ onFail: () => { }, onRedirect }, instrumentAdvancedOptions))
          : dispatch(validateThenSave({ studyID, instrument, validationType: path, onRedirect }))
    } else if (path === 'schedules') {
      // All Schedules is a deploy/review step only. Breadcrumb navigation must not re-validate
      // the survey/clinro/diary editor, which may be unloaded when landing on this route directly.
      shouldSave = false
    } else if (path === 'scoring') {
      if (isClinro) {
        shouldSave =
          !_compareInstruments(clinroEditor.clinro, clinroEditor.originalClinro) ||
          hasScoreErrors ||
          hasMissingSymbolKey
        action = () => dispatch(validateClinroAndSave({ studyID, clinroEditor, onRedirect, path }))
      } else if (isSurvey) {
        shouldSave =
          !_compareInstruments(surveyEditor.survey, surveyEditor.originalSurvey) ||
          hasScoreErrors ||
          hasMissingSymbolKey
        action = () => dispatch(validateSurveyAndSave({ studyID, surveyEditor, onRedirect, path }))
      } else if (isDiary) {
        shouldSave = !_compareInstruments(diaryEditor.diary, diaryEditor.originalDiary) || hasScoreErrors
        action = () => dispatch(validateDiaryAndSave({ studyID, diaryEditor, onRedirect, path }))
      }
    } else if (path === 'uploadinstrument' || (path === 'instruments' && !!upload.uploadedSurvey)) {
      shouldSave = upload.uploadedSurvey !== null
      action = () => dispatch(saveUploadedInstrumentToDatabase(studyID, upload.uploadedSurvey)).then(onRedirect)
    } else if (isSurvey) {
      shouldSave =
        path === 'createinstrument' ||
        !_compareInstruments(surveyEditor.survey, surveyEditor.originalSurvey) ||
        hasScoreErrors ||
        hasMissingSymbolKey
      action = () => dispatch(validateSurveyAndSave({ studyID, surveyEditor, onRedirect, redirect: redirectPath }))
    } else if (isClinro) {
      shouldSave =
        path === 'createclinro' ||
        !_compareInstruments(clinroEditor.clinro, clinroEditor.originalClinro) ||
        hasScoreErrors ||
        hasMissingSymbolKey
      action = () => dispatch(validateClinroAndSave({ studyID, clinroEditor, onRedirect, redirect: redirectPath }))
    } else if (isDiary) {
      shouldSave =
        path === 'creatediary' || !_compareInstruments(diaryEditor.diary, diaryEditor.originalDiary) || hasScoreErrors
      action = () => dispatch(validateDiaryAndSave({ studyID, diaryEditor, onRedirect, redirect: redirectPath }))
    }

    if (!shouldSave) {
      onRedirect()
    } else if (showModal) {
      if (path === 'consent' && !!consentProps) {
        dispatch(
          modalActions.openModal({
            onConfirm: () => {
              if (typeof confirmQuery === 'string') queryParams = confirmQuery
              action()
            },
            content: MODAL_CONTENT_MAP.updateConsent,
            confirmButton: MODAL_BUTTONS_MAP.yesUpdateConsent,
            cancelButton: MODAL_BUTTONS_MAP.cancel,
            className: MODAL_CLASSES_MAP.confirmation,
          }),
        )
      } else {
        if (isReadOnlyState) {
          if (typeof confirmQuery === 'string') queryParams = confirmQuery
          action()
        } else {
          dispatch(
            modalActions.openModal({
              onConfirm: () => {
                if (typeof confirmQuery === 'string') queryParams = confirmQuery
                action()
              },
              onCancel: resJson => {
                if (typeof cancelQuery === 'string') queryParams = cancelQuery
                onRedirect(resJson, true)
              },
              content: MODAL_CONTENT_MAP.saveChanges,
              confirmButton: MODAL_BUTTONS_MAP.yes,
              cancelButton: MODAL_BUTTONS_MAP.no,
              className: MODAL_CLASSES_MAP.confirmation,
              closeOnBackgroundClick: false,
            }),
          )
        }
      }
    } else {
      action()
    }
  }
}

const _handleInstrumentErrors = errors => dispatch => {
  dispatch(setErrors(errors))
  dispatch(
    notyActions.showError({
      text: generateNotyMessage(formatInstrumentValidationNotyMessage(errors), false),
    }),
  )
}

const getSchedulerValidationCategories = errorKeys => {
  const keys = errorKeys || []
  const hasPrefix = prefix => keys.some(key => key?.startsWith(prefix))
  const hasAny = arr => arr.some(item => keys.includes(item))
  const categories = []

  if (hasAny(['inInstrumentLoop', 'invalidInstrumentTrigger', 'noVisit', 'noVisits'])) {
    categories.push('prevalidated_scheduler_rules')
  }
  if (hasPrefix('schedule.recurring')) categories.push('recurrence')
  if (hasPrefix('schedule.visibility') || keys.includes('schedule.recurring.visible_days')) {
    categories.push('visibility')
  }
  if (hasPrefix('schedule.cohort')) categories.push('deployment_audience')
  if (hasPrefix('schedule.deploy') || hasPrefix('schedule.expire') || hasPrefix('schedule.chain')) {
    categories.push('deployment_timing')
  }
  if (keys.includes('conditions') || hasPrefix('conditions.')) {
    categories.push('trigger_conditions')
  }

  return categories
}

const validateInstrument = ({
  conditions,
  instrument,
  onValid,
  onInvalid,
  validationType,
  isNewInstArch,
  isInstrumentUnificationEnabled,
  studyVisitSchedule,
  schedulingOptions = {},
}) => {
  const errors =
    validationType === 'properties'
      ? getMetadataErrors(instrument, isNewInstArch, isInstrumentUnificationEnabled)
      : validationType === 'schedule'
        ? getSchedulingErrors(instrument, conditions, studyVisitSchedule, schedulingOptions)
        : { ...getAllErrors(instrument) }

  if (Object.keys(errors).length === 0) {
    onValid()
  } else {
    if (validationType === 'schedule') {
      const errorKeys = Object.keys(errors || {})
      const categories = getSchedulerValidationCategories(errorKeys)
      logSentryEvent({
        message: 'Instrument scheduling validation failed',
        level: 'warning',
        tags: {
          module: 'instrument-scheduler',
          action: 'validateInstrument',
          validationType: 'schedule',
          instrumentType: instrument?.type,
        },
        contexts: {
          validation: {
            instrumentId: instrument?.id,
            errorCount: errorKeys.length,
            errorKeys: errorKeys.slice(0, 20),
            categories,
            hasConditions: Array.isArray(conditions) && conditions.length > 0,
            hasVisitSchedule: Array.isArray(studyVisitSchedule) && studyVisitSchedule.length > 0,
          },
        },
      })
    }
    onInvalid(errors)
  }
}

// Validates surveys before saving and redirecting.
// When validationType === 'schedule', instrument is read from store so audience/filters from
// ParticipantManagement (Schedule tab) are always used; otherwise the passed instrument is used.
const validateThenSave = ({ studyID, instrument, onRedirect, validationType, conditions, syncReviewSettings = false }) => {
  return (dispatch, getState) => {
    const state = getState()
    const { currentStudy } = state.study
    const instrumentReducerState = state.instrumentReducer
    const { instrumentUnificationEnabled } = instrumentReducerState
    const isNewInstArch = currentStudy?.config?.instrument_architecture_version >= 2
    const instrumentToUse =
      validationType === 'schedule' ? instrumentReducerState.instrument : instrument
    const onValid = () => {
      // Properties saves must not establish the schedule version baseline. Otherwise the
      // first real Schedule Instrument save bumps a brand-new schedule from 1 → 2.
      dispatch(
        saveInstrument(studyID, instrumentToUse, false, {
          versionSchedules: validationType === 'schedule',
          syncReviewSettings: syncReviewSettings || validationType === 'properties',
        }),
      ).then(onRedirect)
    }
    const schedulingOptions =
      validationType === 'schedule'
        ? {
          hasMultiSchedule: hasMultiScheduleFeature(currentStudy),
          confirmedSchedules: instrumentReducerState.confirmedSchedules,
          activeScheduleIndex: instrumentReducerState.activeScheduleIndex,
        }
        : {}
    validateInstrument({
      instrument: instrumentToUse,
      validationType,
      onValid,
      onInvalid: errors => dispatch(_handleInstrumentErrors(errors)),
      conditions,
      schedulingOptions,
      isNewInstArch,
      isInstrumentUnificationEnabled: instrumentUnificationEnabled,
    })
  }
}

export const saveInstrumentSitesForPromotion = (studyID, instrument, sitesObj, isAnnouncement = false) => (
  dispatch,
  getState,
) => {
  const { study, location } = getState()
  const { studyVersionList } = study
  const studyVersionID = getStudyVersionID(location)
  const studyVersion = studyVersionList?.find(item => item?.version_id === studyVersionID)
  const currentVersionStatus = studyVersion?.version_status || ''
  const newSelectedSites = Object.keys(sitesObj).map(siteID => Number(siteID))

  const instrumentToSave = { ...instrument }
  const { metadata, title } = instrumentToSave
  const { schedule } = metadata || {}

  // Support multi-schedule array: update sites on the first / matching schedule entry
  const scheduleEntry = Array.isArray(schedule) ? schedule[0] : schedule
  const cohort = scheduleEntry?.cohort
  let sitesEntry = null

  if (Array.isArray(cohort)) {
    // Find the sites entry in the array
    sitesEntry = cohort.find(c => c.type === 'sites' || (c.filter?.site_ids && c.filter.site_ids.length > 0))
  } else if (cohort?.type === 'sites' || (cohort?.filter?.site_ids && cohort.filter.site_ids.length > 0)) {
    sitesEntry = cohort
  }

  if (sitesEntry && scheduleEntry) {
    // Initialize env_config if it doesn't exist
    if (!scheduleEntry.env_config) {
      scheduleEntry.env_config = {}
    }

    if (!sitesEntry.filter) {
      sitesEntry.filter = {}
    }
    sitesEntry.filter.site_ids = newSelectedSites
    scheduleEntry.env_config[currentVersionStatus] = newSelectedSites
  }

  if (isAnnouncement) {
    metadata.display_name = title
  }

  return dispatch(
    saveInstrumentSites(
      studyID,
      studyVersionID,
      instrumentToSave.id,
      metadata,
      getScheduleId(scheduleEntry),
    ),
  ).then(() => dispatch(fetchInstruments({ studyID, hasLoader: true, isAnnouncements: isAnnouncement })))
}

/**
 * Visit-based chain deploy must not include instrument-trigger fields in chain_deployment_info.
 */
export const sanitizeChainDeploymentInfoForPayload = schedule => {
  const chainDeploymentInfo = schedule?.chain_deployment_info
  if (!chainDeploymentInfo) return schedule

  if (chainDeploymentInfo[DEPLOYMENT_KEYS.chainDeployByVisit]) {
    delete chainDeploymentInfo.prev_instrument_id
    delete chainDeploymentInfo.deployment_condition
    delete chainDeploymentInfo.has_chain_deployment
    delete chainDeploymentInfo.cohort
  }
  return schedule
}

const getNewSchedule = (schedule, isNewInstArch) => {
  const newSchedule = { ...schedule }
  const { recurring } = newSchedule

  if (recurring && recurring.scheme !== 'persistent') {
    newSchedule.recurring_cal = recurring
    // Persist the user's repeat configuration in recurring so backend stores it.
    // Do not overwrite with DEFAULT_PERSISTENT_SCHEME or repeat settings are lost (PMT-1537).
  } else {
    if (!recurring) {
      delete newSchedule.recurring_cal
    }
    newSchedule.recurring = DEFAULT_PERSISTENT_SCHEME
  }

  return newSchedule
}

const prepInstrumentForSave = ({
  instrument,
  isNewInstArch = false,
  hasStudyPromotion,
  hasMultiSchedule = false,
  studyVersionList,
  studyVersionID,
  isOnlySiteUpdated,
  confirmedSchedules,
}) => {
  const normalizedInstrument = {
    ...instrument,
    metadata:
      instrument?.type === INSTRUMENT_TYPE_MAP.task
        ? flattenTaskMetadata(instrument.metadata)
        : instrument.metadata,
  }
  const listFromConfirmed = Array.isArray(confirmedSchedules) && confirmedSchedules.length > 0
  // Study flag off → always legacy single schedule object, even if Redux has a list
  const useMultiSchedule = hasMultiSchedule && listFromConfirmed
  const sourceSchedules = useMultiSchedule
    ? ensureScheduleIds(confirmedSchedules)
    : ensureScheduleIds(
      listFromConfirmed ? confirmedSchedules[0] : normalizedInstrument?.metadata?.schedule,
    )

  // Persist as array only when study allows multi-schedule and we have confirmed schedules
  const persistAsArray = useMultiSchedule

  const prepareOneSchedule = rawSchedule => {
    const schedule = ensureScheduleIds(rawSchedule)[0]

    const hasIntentionalAudience =
      schedule.audience_type != null ||
      (schedule.cohort &&
        typeof schedule.cohort === 'object' &&
        !Array.isArray(schedule.cohort) &&
        AUDIENCE_TYPE_VALUES.includes(schedule.cohort.type))
    const normalizedCohort = normalizeScheduleCohort(schedule)
    const audienceType = normalizedCohort.type
    if (hasIntentionalAudience) {
      schedule.audience_type = audienceType
    } else {
      delete schedule.audience_type
    }
    schedule.cohort = buildCohortPayload(normalizedCohort)

    if (INSTRUMENT_TYPES_WITH_SCHEDULE_PLATFORM.includes(normalizedInstrument?.type)) {
      schedule.platform_type = coerceSchedulePlatformType(schedule.platform_type)
    } else {
      delete schedule.platform_type
    }

    if (hasStudyPromotion && !isOnlySiteUpdated) {
      const studyVersion = studyVersionList?.find(item => item?.version_id === studyVersionID)
      const currentVersionStatus = studyVersion?.version_status || ''
      const normalizedForEnv = normalizeScheduleCohort(schedule)
      if (normalizedForEnv?.type === 'sites' || Array.isArray(normalizedForEnv?.filter?.site_ids)) {
        if (!schedule.env_config) {
          schedule.env_config = {}
        }
        schedule.env_config[currentVersionStatus] = normalizedForEnv.filter.site_ids
      }
    }

    if (normalizedInstrument?.type === INSTRUMENT_TYPE_MAP.diary) {
      return sanitizeChainDeploymentInfoForPayload(getNewSchedule(schedule, isNewInstArch))
    }

    if (schedule?.deploy && (schedule.deploy.time_of_day == null || schedule.deploy.time_of_day === '')) {
      schedule.deploy.time_of_day = DEFAULT_DEPLOY_TIME
    }

    return sanitizeChainDeploymentInfoForPayload(schedule)
  }

  const preparedSchedules = sourceSchedules.map(prepareOneSchedule)

  const perScheduleVisibility = usesPerScheduleVisibility(
    hasMultiSchedule,
    preparedSchedules,
    normalizedInstrument?.metadata?.instrument_reuse,
  )
  let metadataForSave = { ...normalizedInstrument.metadata }
  let schedulesAfterVisibility = preparedSchedules

  if (perScheduleVisibility) {
    const applied = applyPerScheduleVisibilityForSave({
      schedules: preparedSchedules,
      metadata: metadataForSave,
      currentSchedule: normalizedInstrument?.metadata?.schedule,
      currentScheduleId: getScheduleId(normalizedInstrument?.metadata?.schedule),
    })
    schedulesAfterVisibility = applied.schedules
    metadataForSave = applied.metadata
  } else {
    const applied = applyMetadataVisibilityForSave({
      schedules: preparedSchedules,
      metadata: metadataForSave,
      currentSchedule: normalizedInstrument?.metadata?.schedule,
    })
    schedulesAfterVisibility = applied.schedules
    metadataForSave = applied.metadata
  }

  const instrumentToSave = {
    ...normalizedInstrument,
    metadata: {
      ...metadataForSave,
      // Persist as array only when study multi_schedule is enabled; otherwise legacy object
      schedule: persistAsArray
        ? schedulesAfterVisibility
        : schedulesAfterVisibility[0] || createBlankSchedule(normalizedInstrument?.type),
      // instrument_reuse metadata only when study flag allows multi-schedule
      instrument_reuse: persistAsArray
        ? schedulesAfterVisibility.length > 1 || !!normalizedInstrument?.metadata?.instrument_reuse
        : false,
    },
  }
  const { type } = instrumentToSave
  const { is_optional } = instrumentToSave.metadata

  // Ensure display_location is set so instrument is visible in web link when Properties page was skipped
  const defaultDisplayLocation = [INSTRUMENT_DISPLAY_LOCATION_OPTIONS.carousel]
  if (!instrumentToSave.metadata.display_location || !instrumentToSave.metadata.display_location.length) {
    instrumentToSave.metadata.display_location = defaultDisplayLocation
    instrumentToSave.metadata.placement = defaultDisplayLocation
  }
  if (hasStudyPromotion && studyVersionID) {
    instrumentToSave.study_version_id = studyVersionID
  }
  const mapProgressWeight = is_optional ? 0.0 : 1.0
  instrumentToSave.map_progress_weight = mapProgressWeight

  if (type === INSTRUMENT_TYPE_MAP.task) {
    const taskName = instrumentToSave.metadata.task_name
    const requiredPermissions = []
    if (TASKS_WITH_AUDIO_PERMISSION.includes(taskName))
      requiredPermissions.push(MOBILE_APP_PERMISSION_NAMES_MAP.audioRecording)
    if (TASKS_WITH_STORAGE_PERMISSION.includes(taskName))
      requiredPermissions.push(MOBILE_APP_PERMISSION_NAMES_MAP.storageAccess)
    instrumentToSave.metadata.required_permissions = requiredPermissions
    instrumentToSave.metadata = enrichTaskMetadataForSave(instrumentToSave.metadata, {
      id: instrumentToSave.id,
      title: instrumentToSave.title,
      task_name: taskName,
    })
  }

  if (instrumentToSave.metadata.display_location?.length) {
    instrumentToSave.metadata.placement = instrumentToSave.metadata.display_location
  } else if (!instrumentToSave.metadata.placement?.length) {
    const fallbackDisplayLocation = [INSTRUMENT_DISPLAY_LOCATION_OPTIONS.carousel]
    instrumentToSave.metadata.display_location = fallbackDisplayLocation
    instrumentToSave.metadata.placement = fallbackDisplayLocation
  }
  return instrumentToSave
}

/**
 * Prepare schedule for API payload: set cohort array from current schedule.
 * Only set audience_type when it was already present or intentionally selected in cohort selection (Schedule tab).
 * Accepts a single schedule object or an array of schedules.
 */
export const prepareScheduleForPayload = (schedule = {}) => {
  const prepareOne = entry => {
    const normalized = normalizeScheduleCohort(entry)
    const result = { ...ensureScheduleIds(entry)[0], cohort: buildCohortPayload(normalized) }
    const hasIntentionalAudience =
      entry.audience_type != null ||
      (entry.cohort &&
        typeof entry.cohort === 'object' &&
        !Array.isArray(entry.cohort) &&
        AUDIENCE_TYPE_VALUES.includes(entry.cohort.type))
    if (hasIntentionalAudience) {
      result.audience_type = normalized.type
    } else {
      delete result.audience_type
    }
    return sanitizeChainDeploymentInfoForPayload(result)
  }

  if (Array.isArray(schedule)) {
    return ensureScheduleIds(schedule).map(prepareOne)
  }
  return prepareOne(schedule)
}

/** No-op for backward compatibility. Audience is now in metadata.schedule.audience_type and cohort array. */
export const ensureCohortAudience = instrumentOrPayload => instrumentOrPayload

/**
 * Route uploaded JSON to the correct instrument save path (Survey / ClinRO / eDiary).
 */
export const saveUploadedInstrumentToDatabase = (studyID, uploadedFile) => {
  return (dispatch, getState) => {
    try {
      const parsed = JSON.parse(uploadedFile?.data || '{}')
      const type = String(parsed?.type || '').toUpperCase()

      if (type === INSTRUMENT_TYPE_MAP.clinro) {
        return dispatch(saveClinroUploadToDatabase(studyID, uploadedFile))
      }
      if (type === INSTRUMENT_TYPE_MAP.diary) {
        return dispatch(saveDiaryUploadToDatabase(studyID, uploadedFile))
      }
      return dispatch(saveSurveyUploadToDatabase(studyID, uploadedFile))
    } catch (err) {
      if (!err?.isMultiScheduleUploadRejected) {
        dispatch(
          notyActions.showError({
            text: generateNotyMessage(err?.message || 'Failed to upload instrument', false),
          }),
        )
      }
      return Promise.reject(err)
    }
  }
}

export const handleDateFilterError = text => dispatch => {
  dispatch(notyActions.showError({ text: generateNotyMessage(text, false) }))
}

const fetchInstrument = (studyID, id) => {
  return dispatch => {
    return dispatch(
      request({
        url: instrumentV2Urls.one(studyID, id, '?include_compliance=false'),
        success: json => Promise.resolve(json),
      }),
    )
  }
}

export const onFetchInstrument = (studyID, id, version, inDrawer) => (dispatch, getStore) => {
  const { study } = getStore()
  const isNewInstArch = study.currentStudy?.config?.instrument_architecture_version >= 2
  if (!inDrawer) dispatch(loadingActions.startLoader(true))
  return dispatch(fetchInstrument(studyID, id))
    .then(json => {
      if (!json) {
        return Promise.reject(new Error('Failed to fetch instrument'))
      }
      _formatOldMetadata(json, isNewInstArch)
      const prevState = getStore().instrumentReducer || {}
      // Preserve in-memory draft when user clicked "+ New Schedule" (activeScheduleIndex null
      // with existing confirmed schedules). A refetch must not wipe the blank draft or reset
      // the index back to the last schedule (which caused replace-instead-of-append).
      const draftingNewSchedule =
        prevState.activeScheduleIndex == null &&
        Array.isArray(prevState.confirmedSchedules) &&
        prevState.confirmedSchedules.length > 0 &&
        String(prevState.instrument?.id) === String(id)

      const hasMultiSchedule = hasMultiScheduleFeature(study.currentStudy)
      const hydratedScheduleList = hydrateSchedulesWithReviewSettings(
        hydrateSchedulesWithVisibility(json.metadata?.schedule, json.metadata, hasMultiSchedule),
      )
      const { confirmedSchedules, activeSchedule } = hydrateSchedulesFromMetadata(hydratedScheduleList)
      if (json.metadata) {
        json.metadata.schedule = draftingNewSchedule
          ? prevState.instrument?.metadata?.schedule || createBlankSchedule(json.type)
          : activeSchedule
      }
      dispatch(setPersistedSchedules(confirmedSchedules))
      if (!draftingNewSchedule) {
        dispatch(setConfirmedSchedules(confirmedSchedules))
        dispatch(setActiveScheduleIndex(confirmedSchedules.length ? confirmedSchedules.length - 1 : null))
      }
      const previousInstrumentId = prevState.instrument?.id
      if (previousInstrumentId && json.id && String(previousInstrumentId) !== String(json.id)) {
        dispatch(clearInstrumentTriggers())
      }
      dispatch(setInstrument(json))
      return json
    })
    .then(json => {
      if (!inDrawer) dispatch(loadingActions.stopLoader(true))
      return json
    })
    .catch(err => {
      if (!inDrawer) dispatch(loadingActions.stopLoader(true))
      return Promise.reject(err)
    })
}

const saveInstrument = (studyID, instrument, isOnlySiteUpdated = false, { versionSchedules = true, syncReviewSettings = false } = {}) => {
  return (dispatch, getStore) => {
    const store = getStore()
    const { study, location, instrumentReducer } = store
    const { studyVersionList, currentStudy } = study || {}
    const studyVersionID = getStudyVersionID(location)
    const hasStudyPromotion = !!currentStudy?.config?.study_promotion
    const hasMultiSchedule = hasMultiScheduleFeature(currentStudy)
    const isNewInstArch = currentStudy?.config?.instrument_architecture_version >= 2
    const confirmedSchedules = instrumentReducer?.confirmedSchedules || []

    // Always use schedule (cohort + audience_type) from the instrument reducer so the payload
    // matches the Schedule tab. Prefer the UI cohort object type over a stale audience_type.
    const storeInstrument = instrumentReducer?.instrument
    let scheduleFromStore = null
    if (
      storeInstrument?.id === instrument?.id &&
      storeInstrument?.metadata?.schedule != null &&
      !Array.isArray(storeInstrument.metadata.schedule)
    ) {
      const storeSchedule = storeInstrument.metadata.schedule
      const hasCohortObjectWithType =
        storeSchedule.cohort?.type && AUDIENCE_TYPE_VALUES.includes(storeSchedule.cohort.type)
      const derivedAudienceType = hasCohortObjectWithType
        ? storeSchedule.cohort.type
        : storeSchedule.audience_type
      scheduleFromStore = {
        ...storeSchedule,
        cohort: storeSchedule.cohort,
        audience_type: derivedAudienceType,
      }
      instrument = {
        ...instrument,
        metadata: {
          ...instrument.metadata,
          schedule: {
            ...instrument.metadata.schedule,
            ...scheduleFromStore,
          },
        },
      }
    }

    // Prefer confirmed multi-schedule list; keep editing schedule in sync when list is empty/single-edit.
    let schedulesForSave = confirmedSchedules
    const currentEditorSchedule = scheduleFromStore || storeInstrument?.metadata?.schedule
    if (
      (!schedulesForSave || schedulesForSave.length === 0) &&
      currentEditorSchedule &&
      !Array.isArray(currentEditorSchedule)
    ) {
      schedulesForSave = [
        {
          ...currentEditorSchedule,
          schedule_id: getScheduleId(currentEditorSchedule) || getRandomScheduleId(),
        },
      ]
    } else if (
      schedulesForSave?.length &&
      currentEditorSchedule &&
      !Array.isArray(currentEditorSchedule) &&
      instrumentReducer?.activeScheduleIndex != null
    ) {
      // Merge the currently edited schedule back into the confirmed list before save.
      // Skip when activeScheduleIndex is null (e.g. after delete) so we do not re-append
      // a stale editor schedule that was surgically removed.
      schedulesForSave = commitScheduleToList({
        confirmedSchedules: schedulesForSave,
        currentSchedule: currentEditorSchedule,
        activeScheduleIndex: instrumentReducer?.activeScheduleIndex,
      })
    }

    // Review Screen Settings are edited on Properties but stored on every schedule.
    if (
      storeInstrument?.metadata?.schedule &&
      !Array.isArray(storeInstrument.metadata.schedule) &&
      schedulesForSave?.length
    ) {
      const reviewSourceSchedule = resolveReviewSettingsSourceSchedule(
        storeInstrument.metadata.schedule,
        schedulesForSave,
        { preferEditor: syncReviewSettings },
      )
      schedulesForSave = applyReviewSettingsToAllSchedules(schedulesForSave, reviewSourceSchedule)
    }

    // When multi-schedule is disabled, never save more than one schedule
    const schedulesToNormalize =
      hasMultiSchedule || !schedulesForSave?.length ? schedulesForSave : [schedulesForSave[0]]
    // Versions move only on Add/Edit Schedule saves. Every other save (Properties,
    // instrument content, sites) resends whatever version is already stored.
    const schedulesForPayload = versionSchedules
      ? applyScheduleVersions(schedulesToNormalize, instrumentReducer?.persistedSchedules)
      : keepPersistedScheduleVersions(schedulesToNormalize, instrumentReducer?.persistedSchedules)

    let instrumentToSave = prepInstrumentForSave({
      instrument,
      isNewInstArch,
      hasStudyPromotion,
      hasMultiSchedule,
      studyVersionList,
      studyVersionID,
      isOnlySiteUpdated,
      confirmedSchedules: schedulesForPayload,
    })
    if (versionSchedules) {
      instrumentToSave = applyPersistedMetadataForScheduleSave(
        instrumentToSave,
        instrumentReducer?._instrument || storeInstrument,
      )
    }
    const isReadOnlyState = hasStudyPromotion && isVersionUatOrLive(studyVersionList, studyVersionID)
    const success = () => {
      if (schedulesForPayload?.length) {
        // Baseline only advances when this save intentionally versioned schedules.
        if (versionSchedules) {
          dispatch(setPersistedSchedules(schedulesForPayload))
        }
        dispatch(setConfirmedSchedules(schedulesForPayload))
      }
      if (!versionSchedules) {
        dispatch({ type: SYNC_PERSISTED_INSTRUMENT, instrument: instrumentToSave })
      }
      return Promise.resolve()
    }
    return dispatch(
      request({
        method: 'PUT',
        url: instrumentV2Urls.one(studyID, instrument.id),
        hasLoader: true,
        body: JSON.stringify(buildV2InstrumentUpdateBody(instrumentToSave)),
        failMessage: 'Saving instrument failed',
        successMessage: !isReadOnlyState ? 'Instrument saved successfully' : '',
        success,
      }),
    )
  }
}

// This function saves sites for announcements or instruments when the study has been promoted
const saveInstrumentSites = (studyID, studyVersionID, instrumentID, metadata, scheduleId) => dispatch => {
  const { schedule, version } = metadata
  // Handle missing version gracefully - default to 1 if not present
  const versionValue = version != null ? version : 1

  // Filters apply to one schedule; prefer explicit scheduleId, else first array entry / object
  const scheduleEntry = Array.isArray(schedule)
    ? schedule.find(item => getScheduleId(item) === scheduleId) || schedule[0]
    : schedule
  const normalizedCohort = normalizeScheduleCohort(scheduleEntry || {})

  // For the /filters endpoint, backend expects type to reflect the primary filter dimension.
  // When we have site_ids, send type 'sites' instead of the broader audience type.
  const hasSiteFilter = Array.isArray(normalizedCohort.filter?.site_ids)
  const typeForFilters = hasSiteFilter ? GROUP_TYPE_MAP.sites : normalizedCohort.type

  const body = {
    type: typeForFilters,
    filter: normalizedCohort.filter,
    version: versionValue,
    study_version_id: studyVersionID,
  }
  const resolvedScheduleId = scheduleId || getScheduleId(scheduleEntry)
  if (resolvedScheduleId) {
    body.schedule_id = resolvedScheduleId
  }

  return dispatch(
    runInstrumentV2AsyncJob({
      studyID,
      successMessage: 'Sites saved successfully',
      failMessage: 'Saving sites failed',
      startRequest: request({
        method: 'PUT',
        url: instrumentV2Urls.filters(studyID, instrumentID),
        hasLoader: true,
        body: JSON.stringify(body),
        skipNotySuccess: true,
        success: json => json,
      }),
    }),
  )
}

const fetchInstrumentEvents = (studyID, id) => {
  return dispatch => {
    return dispatch(
      request({
        url: `/control/studies/${studyID}/instruments/${id}/events`,
        success: json => Promise.resolve(json),
        // Events are optional for preview; don't surface a blocking error toast
        fail: () => { },
      }),
    )
  }
}

const clearInstrumentEvents = () => ({
  type: CLEAR_INSTRUMENT_EVENTS,
})

export const onFetchInstrumentEvents = (studyID, id) => {
  return dispatch => {
    dispatch(clearInstrumentEvents())
    return dispatch(fetchInstrumentEvents(studyID, id))
      .then(payload => {
        // Request helper resolves `true` on handled HTTP failures; only accept real payloads
        if (!payload || typeof payload !== 'object') {
          dispatch(setInstrumentEvents({}))
          return
        }
        const events = payload.participant_instrument_progress_by_version
        // Always set (including {}) so the Status section can show an empty state
        dispatch(setInstrumentEvents(events && typeof events === 'object' ? events : {}))
      })
      .catch(() => {
        dispatch(setInstrumentEvents({}))
      })
  }
}

export const deployInstrument = ({
  studyID,
  instrumentID,
  isAnnouncement = false,
  successCallback,
  isConditionalDeployment = false,
}) => {
  return (dispatch, getState) => {
    const { location, study } = getState()
    const studyVersionID = getStudyVersionID(location)
    const hasStudyPromotion = Boolean(study?.currentStudy?.config?.study_promotion)

    const getQueryParams = () => (hasStudyPromotion ? `?study_version_id=${studyVersionID}` : '')

    const _defaultSuccess = () => {
      dispatch(toggleSaveAttempt(false))
      // Keep a global loader visible while react-router loads the next route chunk.
      // Without this, the request loader stops before navigation and the Scheduler flashes for a moment.
      dispatch(loadingActions.startLoader(true, 'routeTransition'))
      browserHistory.push(`/studies/${studyID}/${studyVersionID}/instruments`)

      // Refresh the list after redirect so deployed time/version are current once the page loads.
      dispatch(fetchInstruments({ studyID, hasLoader: true }))
    }
    const success = successCallback || _defaultSuccess
    const successMessage = `${isAnnouncement ? 'Announcement' : 'Instrument'} has been successfully deployed`
    const failMessage = `Failed to deploy ${isAnnouncement ? 'announcement' : 'instrument'}`

    // Show a loader as soon as Proceed is clicked so the page does not look stuck while
    // the deploy request is in flight. Redirect when deploy accepts — do not wait for Jobs.
    dispatch(loadingActions.startLoader(true, 'routeTransition'))

    return dispatch(
      request({
        method: 'POST',
        url: instrumentV2Urls.deploy(studyID, instrumentID, getQueryParams()),
        // Loader is managed above (routeTransition) so it stays up through redirect.
        hasLoader: false,
        hasSender: isAnnouncement,
        skipNotySuccess: true,
        success: json => json,
        fail: (_response, content) =>
          Promise.reject(new Error(content?.message || content?.error || failMessage)),
      }),
    )
      .then(json => {
        // Deploy accepted (sync response or 202 + job_id). Leave any background job alone.
        dispatch(notyActions.showSuccess({ text: generateNotyMessage(successMessage, true) }))
        if (successCallback) {
          // Custom callers (e.g. announcements) manage their own navigation/loading UX.
          dispatch(loadingActions.stopLoader(true, 'routeTransition'))
        }
        success()
        return json
      })
      .catch(err => {
        dispatch(loadingActions.stopLoader(true, 'routeTransition'))
        dispatch(
          notyActions.showError({
            text: generateNotyMessage(err?.message || failMessage, false),
          }),
        )
      })
  }
}

const toggleDeployConfirm = (studyID, instrument) => {
  return (dispatch, getState) => {
    const { confirmedSchedules } = getState().instrumentReducer || {}
    const schedules =
      Array.isArray(confirmedSchedules) && confirmedSchedules.length
        ? confirmedSchedules
        : [instrument?.metadata?.schedule].filter(Boolean)
    const isConditionalDeployment = schedules.some(schedule =>
      Array.isArray(schedule?.chain_deployment_info?.prev_instrument_id),
    )
    const onConfirm = () => {
      dispatch(deployInstrument({ studyID, instrumentID: instrument.id, isConditionalDeployment }))
    }
    dispatch(
      modalActions.openModal({
        content: MODAL_CONTENT_MAP.deployInstrument,
        confirmButton: MODAL_BUTTONS_MAP.proceed,
        cancelButton: MODAL_BUTTONS_MAP.cancel,
        className: MODAL_CLASSES_MAP.confirmation,
        // Do not tie this confirmation modal's disabled state to global mediaUpload loading.
        // This ensures actions like "Next" in Edit Participant Instrument remain enabled
        // even if a media upload is occurring elsewhere.
        ignoreMediaUpload: true,
        onConfirm,
      }),
    )
  }
}

// utils/instrumentHelpers.js or similar
export const normalizeExpiryConditionTerms = instrument => {
  const expiryCondition = instrument?.metadata?.schedule?.chain_expiry_info?.expiry_condition
  if (!expiryCondition) return instrument

  return {
    ...instrument,
    metadata: {
      ...instrument.metadata,
      schedule: {
        ...instrument.metadata?.schedule,
        chain_expiry_info: {
          ...instrument.metadata?.schedule?.chain_expiry_info,
          expiry_condition: {
            ...expiryCondition,
            terms: expiryCondition.terms.map(term => {
              if (term.timeRelated === 'on_the_day') {
                return { ...term, days_offset: 0 }
              } else if (term.timeRelated === 'before') {
                return {
                  ...term,
                  days_offset: term.days_offset === 0 ? 0 : -Math.abs(term.days_offset),
                }
              } else if (term.timeRelated === 'after') {
                return {
                  ...term,
                  days_offset: term.days_offset === 0 ? 0 : Math.abs(term.days_offset),
                }
              }
              return { ...term }
            }),
          },
        },
      },
    },
  }
}

const replaceConditionId = (instrument, conditionIdObj) => {
  const { oldConditionId, newConditionId } = conditionIdObj
  const oldConditionIdIndex = instrument.metadata.conditions.indexOf(oldConditionId)
  instrument.metadata.conditions[oldConditionIdIndex] = newConditionId
}

export const applyConditionSavePayload = (
  instrument,
  payload,
  instrumentTriggers,
  conditionsToDelete = [],
) => {
  const newInstrument = { ...instrument }
  if (!newInstrument.metadata) {
    newInstrument.metadata = {}
  }

  const deletedIds = new Set((conditionsToDelete || []).filter(Boolean))
  const existingConditionIds = Array.isArray(newInstrument.metadata.conditions)
    ? newInstrument.metadata.conditions.filter(id => id && !deletedIds.has(id))
    : []
  newInstrument.metadata.conditions = existingConditionIds

  const hasUpdate = payload?.some(val => !!val?.oldConditionId)
  if (hasUpdate) {
    payload.forEach(condition => {
      if (condition?.oldConditionId) {
        replaceConditionId(newInstrument, condition)
      } else if (condition) {
        newInstrument.metadata.conditions.push(condition)
      }
    })
  } else if (payload) {
    payload.forEach(condition => {
      if (condition) newInstrument.metadata.conditions.push(condition)
    })
  }

  newInstrument.metadata.conditions_data = instrumentTriggers
  return newInstrument
}

const persistInstrumentTriggers = ({
  studyID,
  instrument,
  instrumentTriggers,
  conditionsToDelete = [],
}) => dispatch => {
  const { conditions } = instrumentTriggers || {}
  if (!(conditions?.length > 0 || conditionsToDelete.length > 0)) {
    return Promise.resolve(instrument)
  }
  const conditionParams = {
    studyId: studyID,
    conditions: instrumentTriggers,
    isInstrumentTrigger: true,
  }
  if (conditionsToDelete.length > 0) {
    conditionParams.toDeleteArr = conditionsToDelete
  }
  return dispatch(saveConditions(conditionParams)).then(payload =>
    applyConditionSavePayload(instrument, payload, instrumentTriggers, conditionsToDelete),
  )
}

/**
 *
 * Deploy from All Schedules page using the confirmed schedules list.
 * Skips re-validating the schedule editor (which may be a blank "+ New Schedule" draft).
 */
const deployConfirmedSchedules = ({ onFail } = {}) => {
  return (dispatch, getState) => {
    const { instrumentReducer, study } = getState()
    const { instrument, confirmedSchedules, instrumentTriggers, conditionsToDelete } = instrumentReducer
    const studyID = study.currentStudy.id

    if (!confirmedSchedules?.length) {
      if (onFail) onFail()
      return Promise.resolve()
    }

    dispatch(clearErrors())
    return dispatch(
      persistInstrumentTriggers({
        studyID,
        instrument,
        instrumentTriggers,
        conditionsToDelete,
      }),
    )
      .then(instrumentToSave =>
        dispatch(saveInstrument(studyID, instrumentToSave, false, { versionSchedules: true })).then(() => {
          dispatch(clearConditionsToDelete())
          const conditionIds = instrumentToSave?.metadata?.conditions
          if (conditionIds?.length) {
            return dispatch(fetchInstrumentConditions(studyID, conditionIds)).then(() =>
              dispatch(toggleDeployConfirm(studyID, instrumentToSave)),
            )
          }
          return dispatch(toggleDeployConfirm(studyID, instrumentToSave))
        }),
      )
      .catch(err => {
        if (onFail) onFail()
        return Promise.reject(err)
      })
  }
}

/**
 *
 * This function saves, handles instruments conditions, and triggers the deploy flow of the instrument.
 */
const validateThenDeploy = ({ onFail, onRedirect }, _instrumentAdvancedOptions = null) => {
  return (dispatch, getState) => {
    const { instrumentReducer, study, visitSchedules, surveyEditor, clinroEditor } = getState()
    const convertedAdvancedOptions = convertAdvancedOptions(_instrumentAdvancedOptions)
    const { instrument, instrumentTriggers, conditionsToDelete } = instrumentReducer
    const studyID = study.currentStudy.id
    const { conditions } = instrumentTriggers
    const studyVisitSchedule = visitSchedules?.studyVisitSchedule || []

    const hasAdvancedOptions = checkForAdvancedDeploymentOptions(_instrumentAdvancedOptions)
    if (hasAdvancedOptions && convertedAdvancedOptions) {
      instrument.metadata.schedule.cohort = [...convertedAdvancedOptions]
    }

    if (!hasAdvancedOptions && Array.isArray(instrument.metadata.schedule.cohort)) {
      const normalized = normalizeScheduleCohort(instrument.metadata.schedule)
      instrument.metadata.schedule.cohort = normalized
      if (instrument.metadata.schedule.audience_type != null) {
        instrument.metadata.schedule.audience_type = normalized.type
      }
    }

    let normalizedInstrument = normalizeExpiryConditionTerms(instrument)
    const sequenceWarning =
      getFirstIncompleteTimedMatchingGridSequenceWarning(surveyEditor?.survey?.questions) ||
      getFirstIncompleteTimedMatchingGridSequenceWarning(clinroEditor?.clinro?.questions) ||
      getFirstIncompleteTimedMatchingGridSequenceWarning(normalizedInstrument.questions)
    if (sequenceWarning) {
      onFail()
      dispatch(
        notyActions.showError({
          text: generateNotyMessage(sequenceWarning, false),
        }),
      )
      return
    }

    let onValid = () => {
      dispatch(clearErrors())
      return dispatch(
        saveInstrument(studyID, normalizedInstrument, false, { versionSchedules: true }),
      ).then(() =>
        onRedirect ? onRedirect() : dispatch(toggleDeployConfirm(studyID, normalizedInstrument)),
      )
    }

    const schedulingOptions = {
      hasMultiSchedule: hasMultiScheduleFeature(study?.currentStudy),
      confirmedSchedules: instrumentReducer?.confirmedSchedules,
      activeScheduleIndex: instrumentReducer?.activeScheduleIndex,
    }

    if (conditions?.length > 0 || conditionsToDelete.length > 0) {
      onValid = () => {
        dispatch(clearErrors())
        return dispatch(
          persistInstrumentTriggers({
            studyID,
            instrument: normalizedInstrument,
            instrumentTriggers,
            conditionsToDelete,
          }),
        ).then(newInstrument =>
          dispatch(saveInstrument(studyID, newInstrument, false, { versionSchedules: true })).then(() => {
            dispatch(clearConditionsToDelete())
            const afterSave = () =>
              onRedirect ? onRedirect() : dispatch(toggleDeployConfirm(studyID, newInstrument))
            const conditionIds = newInstrument.metadata?.conditions
            if (conditionIds?.length) {
              return dispatch(fetchInstrumentConditions(studyID, conditionIds)).then(afterSave)
            }
            return afterSave()
          }),
        )
      }
      return validateInstrument({
        instrument: normalizedInstrument,
        validationType: 'schedule',
        onValid,
        onInvalid: errors => {
          onFail()
          return dispatch(_handleInstrumentErrors(errors))
        },
        conditions,
        studyVisitSchedule,
        schedulingOptions,
      })
    }
    return validateInstrument({
      instrument: normalizedInstrument,
      validationType: 'schedule',
      onValid,
      onInvalid: errors => {
        onFail()
        return dispatch(_handleInstrumentErrors(errors))
      },
      studyVisitSchedule,
      schedulingOptions,
    })
  }
}

//
// UTILS
//

export const _getDefaultInstrumentScoringTriggerAction = ({
  instrumentId,
  conditionId,
  startDate = moment.utc().toISOString(),
  virtualVisitsEnabled = true,
  scoreParams = {},
}) => {
  const { score_id, score_name } = scoreParams
  const result = virtualVisitsEnabled
    ? {
      triggers: [
        {
          resource_type: 'instrument_scoring',
          resource_function_name: 'get_instrument_scores',
          resource_function_params: {
            instrument_id: instrumentId,
            instrument_score: '',
            window: 2,
            logical_operator: '>=',
          },
        },
      ],
      action: {
        type: 'create_virtual_visit_emergency_call',
        action_params: {},
      },
      schedule: {
        start_date: startDate,
        recurrence_rule: {
          frequency: 'minutely',
          interval: 2,
        },
      },
    }
    : {
      triggers: [
        {
          resource_type: 'instrument_scoring',
          resource_function_name: 'get_instrument_score_by_name',
          resource_function_params: {
            instrument_id: instrumentId,
            instrument_score: '',
            window: 2,
            logical_operator: '==',
            role_ids: [8],
            score_id,
            score_name,
          },
        },
      ],
      action: {
        type: 'send_email',
        action_params: {
          email_template: 'instrument_score_participant_response',
        },
      },
      schedule: {
        is_manual: true,
      },
    }
  if (conditionId) result.condition_id = conditionId
  return result
}

export const _getDefaultInstrumentComplianceTriggerAction = ({ instrumentId, conditionId }) => {
  const result = {
    triggers: [
      {
        resource_type: 'instrument',
        resource_function_name: 'get_instrument_compliance',
        resource_function_params: {
          completion_comparison: 5,
          instrument_id: instrumentId,
          window: 4320, // 3 days in minutes
          logical_operator: '<',
          role_ids: [3, 4],
        },
      },
    ],
    action: {
      type: 'send_email',
      action_params: {
        email_template: 'instrument_compliance',
      },
    },
    schedule: {
      is_manual: true,
    },
  }
  if (conditionId) result.condition_id = conditionId
  return result
}

export const _getDefaultDiaryTriggerAction = ({
  conditionId,
  instrumentId,
  daysAfterInstrumentDeployment,
  timeString = '09:00',
  date = new Date(),
  recurring,
}) => {
  const startDate = date

  let _daysAfterDeployment = 1
  let _frequencyInterval = 1

  if (daysAfterInstrumentDeployment) {
    _daysAfterDeployment = daysAfterInstrumentDeployment
  }
  if (recurring) {
    const { interval } = recurring
    _daysAfterDeployment = interval
    _frequencyInterval = interval
    if (daysAfterInstrumentDeployment) {
      _daysAfterDeployment += daysAfterInstrumentDeployment - 1
    }
  }

  startDate.setDate(startDate.getDate() + _daysAfterDeployment)

  const [hours, minutes] = timeString.split(':').map(numStr => Number(numStr))
  startDate.setUTCHours(hours, minutes, 0, 0)
  const resultTriggerAction = {
    triggers: [
      {
        resource_type: 'instrument',
        resource_function_name: 'send_new_activity_notification',
        resource_function_params: {
          instrument_id: instrumentId,
          time_of_day: timeString,
        },
      },
    ],
    action: {
      type: 'send_push_notification',
      action_params: {
        title_string_id: 'new_instrument_notification',
      },
    },
    schedule: {
      start_date: startDate, // the notifications should start a day after the initial deployment
      recurrence_rule: {
        frequency: 'daily',
        interval: _frequencyInterval,
        by_hour: [hours],
        by_minute: minutes,
      },
    },
  }
  if (conditionId) resultTriggerAction.condition_id = conditionId
  return resultTriggerAction
}

const generateUpdatedDiaryTriggerAction = ({ conditionId, deploy, instrumentId, recurring }) => {
  let resultTriggerAction
  const { first_login, absolute, time_of_day } = deploy
  if (first_login) {
    const { interval } = first_login
    resultTriggerAction = _getDefaultDiaryTriggerAction({
      conditionId,
      instrumentId,
      daysAfterInstrumentDeployment: interval + 1,
      timeString: time_of_day,
      recurring,
    })
  } else if (absolute) {
    const date = fromEpochToUTC(absolute).toDate()
    resultTriggerAction = _getDefaultDiaryTriggerAction({
      conditionId,
      instrumentId,
      date,
      timeString: time_of_day,
      recurring,
    })
  } else {
    resultTriggerAction = _getDefaultDiaryTriggerAction({ conditionId, instrumentId, recurring })
  }
  return resultTriggerAction
}

const _changeInstrumentTriggerType = ({
  state,
  newType,
  conditionId,
  instrumentId,
  index,
  virtualVisitsEnabled,
  scoreParams,
}) => {
  const newState = { ...state }
  switch (newType) {
    case TRIGGER_TYPE_MAP.score:
      newState.conditions[index] = _getDefaultInstrumentScoringTriggerAction({
        instrumentId,
        conditionId,
        virtualVisitsEnabled,
        scoreParams,
      })
      return newState
    case TRIGGER_TYPE_MAP.compliance:
      newState.conditions[index] = _getDefaultInstrumentComplianceTriggerAction({ instrumentId, conditionId })
      return newState
    default:
      return newState
  }
}

//
// ACTION CREATORS
//

const updateMetadataField = (field, value, errorPath) => {
  return {
    type: UPDATE_METADATA_FIELD,
    field,
    value,
    errorPath,
  }
}

const deleteMetadataField = field => {
  return {
    type: DELETE_METADATA_FIELD,
    field,
  }
}

const updateInstrumentTitle = title => {
  return {
    type: UPDATE_INSTRUMENT_TITLE,
    title,
  }
}

const updateInstrumentDisplayLocation = displayLocation => {
  return {
    type: UPDATE_INSTRUMENT_DISPLAY_LOCATION,
    displayLocation,
  }
}

const setErrors = errors => {
  return {
    type: SET_ERRORS,
    errors,
  }
}

const clearErrors = () => ({ type: CLEAR_ERRORS })

const updateSchedule = (key, obj) => {
  return {
    type: UPDATE_SCHEDULE,
    key,
    obj,
  }
}

const updateScheduleField = (key, field, value, errorPath) => {
  return {
    type: UPDATE_SCHEDULE_FIELD,
    key,
    field,
    value,
    errorPath,
  }
}

const deleteMetadataKey = (key, field) => {
  if (key === 'schedule') {
    return {
      type: DELETE_SCHEDULE_FIELD,
      field,
    }
  }
}

const removeChainDeploymentInfo = () => {
  return {
    type: REMOVE_CHAIN_DEPLOYMENT_INFO,
  }
}

const updateVisibility = (key, value, options = {}) => {
  return {
    type: UPDATE_VISIBILITY,
    key,
    value,
    onSchedule: options.onSchedule,
  }
}

const addVisibilityRange = (options = {}) => {
  return {
    type: ADD_VISIBILITY_RANGE,
    onSchedule: options.onSchedule,
  }
}

const updateVisibilityRange = (idx, key, value, options = {}) => {
  return {
    type: UPDATE_VISIBILITY_RANGE,
    idx,
    key,
    value,
    onSchedule: options.onSchedule,
  }
}

const updateGeofenceEnabled = value => {
  return {
    type: UPDATE_GEOFENCE_ENABLED,
    value,
  }
}

const updateInstrumentRoles = rolesArr => {
  return {
    type: UPDATE_INSTRUMENT_ROLES,
    instrumentRoles: rolesArr,
  }
}

export const setInstrument = instrument => {
  return {
    type: SET_INSTRUMENT,
    payload: instrument,
  }
}

export const resetInstrument = instrumentType => {
  return {
    type: RESET_INSTRUMENT,
    instrumentType,
  }
}

export const resetSchedule = () => {
  return {
    type: RESET_SCHEDULE,
  }
}

export const setConfirmedSchedules = schedules => ({
  type: SET_CONFIRMED_SCHEDULES,
  schedules: ensureScheduleIds(schedules),
})

/** Snapshot of the schedules currently stored in the database, used to resolve versions on save. */
export const setPersistedSchedules = schedules => ({
  type: SET_PERSISTED_SCHEDULES,
  schedules: ensureScheduleIds(schedules),
})

export const setActiveScheduleIndex = index => ({
  type: SET_ACTIVE_SCHEDULE_INDEX,
  index,
})

export const commitCurrentSchedule = () => (dispatch, getState) => {
  dispatch({ type: COMMIT_CURRENT_SCHEDULE })
  const { confirmedSchedules } = getState().instrumentReducer
  return confirmedSchedules
}

export const deleteConfirmedSchedule = index => (dispatch, getState) => {
  const { study, location, instrumentReducer } = getState()
  const { confirmedSchedules, instrument } = instrumentReducer || {}
  if (!hasMultiScheduleFeature(study?.currentStudy)) return Promise.resolve()
  if (!confirmedSchedules || confirmedSchedules.length <= 1) return Promise.resolve()

  const schedule = confirmedSchedules[index]
  const scheduleId = getScheduleId(schedule)
  const studyID = study?.currentStudy?.id
  const studyVersionID = getStudyVersionID(location)
  const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
  const instrumentID = instrument?.id
  const remainingSchedules = confirmedSchedules.filter((_, i) => i !== index)

  const applyLocalDelete = () => {
    dispatch({ type: DELETE_CONFIRMED_SCHEDULE, index, remainingSchedules })
  }

  // Local-only draft (not yet persisted with schedule_id / no instrument id): Redux only
  if (!studyID || !instrumentID || !scheduleId) {
    applyLocalDelete()
    return Promise.resolve()
  }

  const query = hasStudyPromotion && studyVersionID ? `?study_version_id=${studyVersionID}` : ''

  return dispatch(
    runInstrumentV2AsyncJob({
      studyID,
      successMessage: 'Schedule deleted successfully',
      failMessage: 'Failed to delete schedule',
      startRequest: request({
        method: 'DELETE',
        url: instrumentV2Urls.schedule(studyID, instrumentID, scheduleId, query),
        // No body — omit Content-Type so browsers don't omit Content-Length while advertising JSON
        contentType: null,
        hasLoader: true,
        skipNotySuccess: true,
        success: json => json,
        // request.js resolves on HTTP errors by default; reject so Redux is not cleared
        fail: (_response, content) =>
          Promise.reject(new Error(content?.message || 'Failed to delete schedule')),
      }),
    }),
  ).then(() => {
    // Surgical DELETE already persisted remaining schedules on the server — no Schedule Instrument needed
    applyLocalDelete()
  })
}

export const startNewSchedule = () => (dispatch, getState) => {
  const { study, instrumentReducer } = getState()
  if (!hasMultiScheduleFeature(study?.currentStudy)) return
  const { instrument, confirmedSchedules } = instrumentReducer || {}
  dispatch({ type: START_NEW_SCHEDULE, instrumentType: instrument?.type })
  const usePerScheduleVisibility = usesPerScheduleVisibility(
    true,
    confirmedSchedules,
    instrument?.metadata?.instrument_reuse,
  )
  if (usePerScheduleVisibility) {
    dispatch(updateVisibility('visibility', DEFAULT_VISIBILITY, { onSchedule: true }))
    dispatch(
      updateVisibility(
        'visibilityRanges',
        DEFAULT_VISIBILITY_RANGES.map(range => ({ ...range })),
        { onSchedule: true },
      ),
    )
  }
  // Explicitly clear edit index so Review appends instead of replacing
  dispatch(setActiveScheduleIndex(null))
}

export const loadScheduleForEdit = index => (dispatch, getState) => {
  const { confirmedSchedules } = getState().instrumentReducer
  const schedule = confirmedSchedules?.[index]
  if (!schedule) return
  dispatch({
    type: LOAD_SCHEDULE_FOR_EDIT,
    index,
    schedule: cloneSchedule(schedule),
  })
  dispatch(setActiveScheduleIndex(index))
}

/**
 * GOLD-10124: Validate the current schedule editor form, commit it into the
 * confirmed schedules list, then navigate to the All Schedules page.
 */
const validateThenReviewSchedule = ({ onFail } = {}, _instrumentAdvancedOptions = null) => {
  return (dispatch, getState) => {
    const { instrumentReducer, study, visitSchedules, location } = getState()
    const convertedAdvancedOptions = convertAdvancedOptions(_instrumentAdvancedOptions)
    const { instrument, instrumentTriggers, confirmedSchedules, activeScheduleIndex } = instrumentReducer
    const studyID = study.currentStudy.id
    const studyVersionID = getStudyVersionID(location)
    const { conditions } = instrumentTriggers
    const studyVisitSchedule = visitSchedules?.studyVisitSchedule || []

    const hasAdvancedOptions = checkForAdvancedDeploymentOptions(_instrumentAdvancedOptions)
    if (hasAdvancedOptions && convertedAdvancedOptions) {
      instrument.metadata.schedule.cohort = [...convertedAdvancedOptions]
    }

    if (!hasAdvancedOptions && Array.isArray(instrument.metadata.schedule.cohort)) {
      const normalized = normalizeScheduleCohort(instrument.metadata.schedule)
      instrument.metadata.schedule.cohort = normalized
      if (instrument.metadata.schedule.audience_type != null) {
        instrument.metadata.schedule.audience_type = normalized.type
      }
    }

    instrument.metadata.schedule = ensureScheduleIds(instrument.metadata.schedule)[0]
    // Keep draft trigger config on the instrument so Review → Edit Schedule remounts
    // can restore it after the scheduler route clears/rehydrates trigger state.
    instrument.metadata.conditions_data = instrumentTriggers

    const onValid = () => {
      dispatch(clearErrors())
      const hasMultiSchedule = hasMultiScheduleFeature(study?.currentStudy)
      // Flag off: always replace the single schedule (never append a second)
      const indexForCommit =
        hasMultiSchedule
          ? activeScheduleIndex
          : confirmedSchedules?.length
            ? 0
            : null
      const nextSchedules = commitScheduleToList({
        confirmedSchedules: hasMultiSchedule ? confirmedSchedules : confirmedSchedules?.slice(0, 1) || [],
        currentSchedule: instrument.metadata.schedule,
        activeScheduleIndex: indexForCommit,
      })
      const schedulesToStore = hasMultiSchedule ? nextSchedules : nextSchedules.slice(0, 1)
      const committedScheduleIndex =
        indexForCommit == null ? schedulesToStore.length - 1 : indexForCommit
      dispatch(setConfirmedSchedules(schedulesToStore))
      dispatch(setActiveScheduleIndex(committedScheduleIndex))
      browserHistory.push(
        `/studies/${studyID}/${studyVersionID}/instruments/${instrument.id}/schedules`,
      )
    }

    return validateInstrument({
      instrument,
      validationType: 'schedule',
      onValid,
      onInvalid: errors => {
        if (onFail) onFail()
        return dispatch(_handleInstrumentErrors(errors))
      },
      conditions,
      studyVisitSchedule,
      schedulingOptions: {
        hasMultiSchedule: hasMultiScheduleFeature(study?.currentStudy),
        confirmedSchedules,
        activeScheduleIndex,
      },
    })
  }
}

const toggleSaveAttempt = bool => {
  return {
    type: TOGGLE_SAVE_ATTEMPT,
    bool,
  }
}

const setInstrumentEvents = instrumentEvents => {
  return {
    type: SET_INSTRUMENT_EVENTS,
    instrumentEvents,
  }
}

const addInstrumentTrigger = ({
  instrumentId,
  isScoringTrigger = false,
  trigger,
  virtualVisitsEnabled,
  scoreParams,
}) => {
  return {
    type: ADD_INSTRUMENT_TRIGGER,
    trigger:
      trigger ||
      (isScoringTrigger
        ? _getDefaultInstrumentScoringTriggerAction({ instrumentId, virtualVisitsEnabled, scoreParams })
        : _getDefaultInstrumentComplianceTriggerAction({ instrumentId })),
  }
}

const addDiaryNotificationTrigger = ({ instrumentId }) => {
  return {
    type: ADD_DIARY_NOTIFICATION_TRIGGER,
    trigger: _getDefaultDiaryTriggerAction({ instrumentId }),
  }
}

const updateDiaryNotificationTrigger = ({ deploy, instrumentId, conditionId, recurring }) => {
  return {
    type: UPDATE_DIARY_NOTIFICATION_TRIGGER,
    conditionId,
    deploy,
    instrumentId,
    recurring,
  }
}

const changeTriggerType = ({ instrumentId, index, conditionId, newType, virtualVisitsEnabled, scoreParams }) => {
  return {
    type: CHANGE_INSTRUMENT_TRIGGER_TYPE,
    index,
    instrumentId,
    conditionId,
    newType,
    virtualVisitsEnabled,
    scoreParams,
  }
}

const deleteInstrumentTrigger = (index, conditionId) => {
  return {
    type: DELETE_INSTRUMENT_TRIGGER,
    index,
    conditionId,
  }
}

const updateInstrumentTrigger = ({ key, value, key2, value2 }, index, isRootTrigger) => {
  return {
    type: UPDATE_INSTRUMENT_TRIGGER,
    key,
    value,
    key2,
    value2,
    index,
    isRootTrigger,
  }
}
const updateInstrumentAction = ({ key, value, key2, value2, score }, index) => {
  return {
    type: UPDATE_INSTRUMENT_ACTION,
    key,
    value,
    key2,
    value2,
    index,
    score,
  }
}

export const clearInstrumentTriggers = (options = {}) => {
  return {
    type: CLEAR_INSTRUMENT_TRIGGERS,
    needsHydration: options?.needsHydration === true,
  }
}

const clearConditionsToDelete = () => {
  return {
    type: CLEAR_INSTRUMENT_CONDITIONS_TO_DELETE,
  }
}

const updatePrevalidatedErrors = obj => {
  return {
    type: UPDATE_PREVALIDATED_ERRORS,
    prevalErrors: obj,
  }
}

const clearPrevalidatedError = errorKey => {
  return {
    type: CLEAR_PREVALIDATED_ERROR,
    errorKey,
  }
}

const setAdvancedOptionsToStore = value => {
  return {
    type: SET_ADVANCED_OPTIONS,
    value,
  }
}

const resetInstrumentAdvancedOptions = () => {
  return {
    type: RESET_ADVANCED_OPTIONS,
  }
}

const setInstrumentUnificationEnabled = value => {
  return {
    type: SET_INSTRUMENT_UNIFICATION_ENABLED,
    value,
  }
}

const resetInstrumentUnificationEnabled = () => {
  return {
    type: RESET_INSTRUMENT_UNIFICATION_ENABLED,
  }
}

//
// UTILS
//

const _redirect = (
  redirect,
  studyID,
  instrumentID,
  consentProps,
  queryParams,
  studyVersionID = '',
  locationState,
) => {
  if (redirect) {
    if (redirect === 'e-consent') {
      browserHistory.push(`/studies/${studyID}/${studyVersionID}/e-consent${queryParams || ''}`)
    } else if (redirect === 'consents') {
      browserHistory.push(`/studies/${studyID}/${studyVersionID}/consents${queryParams || ''}`)
    } else if (['schedule', 'editconsent', 'formatting'].includes(redirect) && !!consentProps) {
      const { consent_id: consentId, consent_version: consentVersion, isUpdate } = consentProps
      const _instrumentId = consentId || instrumentID
      if (isUpdate) {
        browserHistory.push(
          `/studies/${studyID}/${studyVersionID}/consents/${_instrumentId}/${consentVersion}/${redirect}${queryParams ||
          ''}`,
        )
      } else {
        const _consentVersion = consentVersion ? consentVersion + 1 : 1
        browserHistory.push(
          `/studies/${studyID}/${studyVersionID}/consents/${_instrumentId}/${_consentVersion}/${redirect}${queryParams ||
          ''}`,
        )
      }
    } else if (['properties', 'schedule', 'deploy'].includes(redirect) && !!consentProps) {
      const { consent_id: consentId, consent_version: consentVersion } = consentProps
      browserHistory.push(
        `/studies/${studyID}/${studyVersionID}/consents/${consentId}/${consentVersion}/${redirect}${queryParams || ''}`,
      )
    } else if (redirect === 'createconsent') {
      browserHistory.push(`/studies/${studyID}/${studyVersionID}/consents/${redirect}${queryParams || ''}`)
    } else if (redirect === 'consent-preview') {
      browserHistory.push(`/studies/${studyID}/${studyVersionID}/e-consent/consent/preview${queryParams || ''}`)
    } else if (redirect === 'instruments' || instrumentID === undefined) {
      browserHistory.push(`/studies/${studyID}/${studyVersionID}/instruments${queryParams || ''}`)
    } else {
      const pathname = `/studies/${studyID}/${studyVersionID}/instruments/${instrumentID}/${redirect}${queryParams || ''}`
      if (locationState) {
        browserHistory.push({ pathname, state: locationState })
      } else {
        browserHistory.push(pathname)
      }
    }
  }
}

export const formatChainedDeployment = schedule => {
  const { chain_deployment_info } = schedule
  if (chain_deployment_info) {
    if (chain_deployment_info[DEPLOYMENT_KEYS.chainDeployByVisit]) {
      sanitizeChainDeploymentInfoForPayload(schedule)
      return
    }

    const { cohort, deployment_condition, prev_instrument_id } = chain_deployment_info

    const termObject = { instrument_id: prev_instrument_id }
    const _deploymentCondition = {}

    if (!Array.isArray(prev_instrument_id)) {
      schedule.chain_deployment_info.prev_instrument_id = [prev_instrument_id]
    }
    if (cohort) {
      termObject.cohort = { ...cohort }
      delete schedule.chain_deployment_info.cohort
    }
    if (!deployment_condition) {
      _deploymentCondition.operator = 'AND'
      _deploymentCondition.terms = [termObject]
    }
    schedule.chain_deployment_info.deployment_condition = deployment_condition || _deploymentCondition
  }
}

const _formatScheduleEntry = (schedule, instrument) => {
  if (!schedule || typeof schedule !== 'object' || Array.isArray(schedule)) return

  const isDiary = instrument?.type === INSTRUMENT_TYPE_MAP.diary

  // Normalize cohort shape for UI; for existing instruments leave audience_type as-is if not present/null
  const normalizedCohort = normalizeScheduleCohort(schedule)
  schedule.cohort = normalizedCohort
  if (schedule.audience_type != null) {
    schedule.audience_type = normalizedCohort.type
  }
  // else: keep audience_type as-is (undefined/null) for existing instruments

  // Ensure deploy/expire objects exist so legacy formatting does not throw
  if (!schedule.deploy || typeof schedule.deploy !== 'object') {
    schedule.deploy = { now: null }
  }
  if (!schedule.expire || typeof schedule.expire !== 'object') {
    schedule.expire = { never: null }
  }

  // expiration cannot be absolute if deployment schedule is relative
  if ('first_login' in schedule.deploy && 'absolute' in schedule.expire) {
    schedule.expire = { never: null }
  }

  // remove old 'deploy_time' keys and convert to 'first_login'
  if (schedule.expire.deploy_time) {
    schedule.expire.first_login = schedule.expire.deploy_time
    schedule.expire.first_login.interval =
      schedule.expire.first_login.interval + (schedule.deploy.first_login?.interval || 0)
    delete schedule.expire.deploy_time
  }

  // convert all week interval types to days
  if (schedule.deploy.first_login && schedule.deploy.first_login.interval_type === 'weeks') {
    schedule.deploy.first_login.interval *= 7
    schedule.deploy.first_login.interval_type = 'days'
  }
  if (schedule.expire.first_login && schedule.expire.first_login.interval_type === 'weeks') {
    schedule.expire.first_login.interval *= 7
    schedule.expire.first_login.interval_type = 'days'
  }

  // handle legacy recurring formats
  if (schedule.recurring) {
    if (schedule.recurring.interval_type === 'weeks') {
      schedule.recurring.interval *= 7
      schedule.recurring.interval_type = 'days'
    }
    if ('persistent' in schedule.recurring) {
      schedule.recurring = { ...schedule.recurring, ...DEFAULT_PERSISTENT_SCHEME }
    } else if (
      schedule.recurring.scheme !== 'persistent' &&
      schedule.recurring.scheme !== 'n-hours' &&
      schedule.recurring.scheme !== 'n-minutes' &&
      schedule.recurring.scheme !== 'n-months'
    ) {
      schedule.recurring.scheme = 'n-days'
      if (!('visible_days' in schedule.recurring)) {
        schedule.recurring.visible_days = schedule.recurring.interval
      }
    }
    // Normalize incomplete repeat config so days drop-down and UI don't reset (PMT-1537)
    if (
      schedule.recurring.scheme === 'n-days' ||
      schedule.recurring.scheme === 'n-months' ||
      schedule.recurring.scheme === 'n-hours' ||
      schedule.recurring.scheme === 'n-minutes'
    ) {
      if (schedule.recurring.interval == null || schedule.recurring.interval < 1) {
        schedule.recurring.interval = 1
      }
      if (
        (schedule.recurring.scheme === 'n-days' || schedule.recurring.scheme === 'n-months') &&
        !('visible_days' in schedule.recurring)
      ) {
        schedule.recurring.visible_days = schedule.recurring.interval
      }
    }
  }
  if (isDiary) {
    // Prefer recurring_cal when present (legacy); otherwise keep recurring from API
    // so repeat configuration persisted in schedule.recurring (PMT-1537) is preserved.
    if (schedule.recurring_cal) {
      schedule.recurring = schedule.recurring_cal
    }
    // If no recurring_cal and recurring was already overwritten to persistent by old save
    // path, schedule.recurring remains persistent; otherwise it keeps n-days etc. from API.
  }
  // GOLD-11304: Ensure deploy.time_of_day is set when missing (any deploy type) so UI and
  // downstream have 9 AM default; prevents API/Survey JSON missing the field.
  if (schedule.deploy && (schedule.deploy.time_of_day == null || schedule.deploy.time_of_day === '')) {
    schedule.deploy.time_of_day = DEFAULT_DEPLOY_TIME
  }
  /**
   * This will handle converting old chained deployemnt schemas into the new schema shape
   */
  if (schedule.chain_deployment_info) {
    formatChainedDeployment(schedule)
  }
  if (INSTRUMENT_TYPES_WITH_SCHEDULE_PLATFORM.includes(instrument?.type)) {
    const hasPlatformType = Object.prototype.hasOwnProperty.call(schedule, 'platform_type')
    const hasLegacyTargetPlatforms = Object.prototype.hasOwnProperty.call(schedule, 'target_platforms')
    if (hasPlatformType || hasLegacyTargetPlatforms) {
      schedule.platform_type = coerceSchedulePlatformType(
        schedule.platform_type ?? schedule.target_platforms,
      )
    } else {
      delete schedule.platform_type
    }
    delete schedule.target_platforms
  }
}

const _formatOldMetadata = (instrument, isNewInstArch) => {
  if (!instrument) return
  if (instrument.metadata == null) {
    instrument.metadata = _getDefaultMetadata(instrument.type)
  }
  if (instrument.type === INSTRUMENT_TYPE_MAP.task) {
    instrument.metadata = flattenTaskMetadata(instrument.metadata)
  }
  const { metadata } = instrument
  const { schedule, is_optional } = metadata
  if (schedule) {
    // Backward compatible: schedule may be a single object or an array of schedules.
    // Do not convert visibilityRanges to moment objects — the recursive validator
    // would treat moment internals (e.g. `_pf.meridiem`) as empty fields (GOLD-12318).
    if (Array.isArray(schedule)) {
      schedule.forEach(entry => _formatScheduleEntry(entry, instrument))
    } else {
      _formatScheduleEntry(schedule, instrument)
    }
  } else {
    metadata.schedule = _getDefaultMetadata().schedule
  }
  if (is_optional === undefined) {
    metadata.is_optional = false
  }
  // Default display_location so instrument is visible in web link when Properties page was skipped
  const defaultDisplayLocation = [INSTRUMENT_DISPLAY_LOCATION_OPTIONS.carousel]
  if (!metadata.display_location || !metadata.display_location.length) {
    metadata.display_location = defaultDisplayLocation
    metadata.placement = defaultDisplayLocation
    if (instrument) instrument.display_location = defaultDisplayLocation
  }
  return schedule
}

const defaultInstrumentEvents = {
  scheduled: [],
  received: [],
  seen: [],
  opened: [],
  completed: [],
}

const _formatInstrumentEvents = eventsObj => {
  if (!eventsObj || typeof eventsObj !== 'object') {
    return { ...defaultInstrumentEvents }
  }
  const events = { ...defaultInstrumentEvents }
  Object.keys(eventsObj).forEach(eventType => {
    if (eventType === 'message' || eventType === 'instrument_version') return
    const value = eventsObj[eventType]
    events[eventType] = Array.isArray(value) ? uniqueArr(value) : []
  })
  return events
}

export const _getDefaultInstrument = (type = '') => {
  return {
    type,
    title: '',
    metadata: _getDefaultMetadata(type),
    is_geofencing_enabled: false,
    instrument_roles:
      type === INSTRUMENT_TYPE_MAP.clinro
        ? CLINRO_NON_SP_ROLE_IDS
        : [],
  }
}

const addInstrumentPermissions = instrument => {
  if (!instrument) return instrument
  const { type, instrument_roles: instrumentRoles } = instrument
  if (instrumentRoles?.length === 0 && type === INSTRUMENT_TYPE_MAP.clinro) {
    instrument.instrument_roles = CLINRO_NON_SP_ROLE_IDS
  }
  return instrument
}

//
// REDUCERS
//

export const errors = (state = {}, action) => {
  const newState = { ...state }
  switch (action.type) {
    case SET_ERRORS:
      return action.errors
    case UPDATE_SCHEDULE_FIELD:
    case UPDATE_METADATA_FIELD:
      if (state.hasOwnProperty(action.errorPath) && !_isInvalid(action.value)) {
        delete newState[action.errorPath]
        return newState
      }
      return state
    case SET_INSTRUMENT:
    case CLEAR_ERRORS:
    case UPDATE_SCHEDULE:
      return {}
    default:
      return state
  }
}

export const deployedAttempted = (state = false, action) => {
  switch (action.type) {
    case TOGGLE_SAVE_ATTEMPT:
      return action.bool === undefined ? !state : action.bool
    default:
      return state
  }
}

const _instrument = (state = {}, action) => {
  switch (action.type) {
    case SET_INSTRUMENT:
      if (!action.payload) return state
      try {
        return JSON.parse(JSON.stringify(action.payload))
      } catch (error) {
        console.error('Error parsing instrument payload:', error, action.payload)
        return state
      }
    case SYNC_PERSISTED_INSTRUMENT:
      if (!action.instrument) return state
      try {
        return JSON.parse(JSON.stringify(action.instrument))
      } catch (error) {
        console.error('Error parsing persisted instrument snapshot:', error, action.instrument)
        return state
      }
    default:
      return state
  }
}

const isEdited = (state = false, action) => {
  switch (action.type) {
    case SET_INSTRUMENT:
      return false
    case UPDATE_SCHEDULE:
    case UPDATE_SCHEDULE_FIELD:
    case DELETE_SCHEDULE_FIELD:
    case DELETE_METADATA_FIELD:
    case UPDATE_METADATA_FIELD:
    case UPDATE_VISIBILITY:
    case ADD_VISIBILITY_RANGE:
    case UPDATE_VISIBILITY_RANGE:
    case UPDATE_GEOFENCE_ENABLED:
    case UPDATE_INSTRUMENT_ROLES:
    case REMOVE_CHAIN_DEPLOYMENT_INFO:
    case SET_CONFIRMED_SCHEDULES:
    case DELETE_CONFIRMED_SCHEDULE:
    case START_NEW_SCHEDULE:
    case LOAD_SCHEDULE_FOR_EDIT:
      return true
    default:
      return state
  }
}

const instrumentEvents = (state = defaultInstrumentEvents, action) => {
  switch (action.type) {
    case SET_INSTRUMENT_EVENTS:
      return _formatInstrumentEvents(action.instrumentEvents)
    case CLEAR_INSTRUMENT_EVENTS:
      return { ...defaultInstrumentEvents }
    default:
      return state
  }
}

export const instrumentTriggers = (state = { conditions: [] }, action) => {
  const newState = { ...state }
  switch (action.type) {
    case SET_INSTRUMENT: {
      const nextId = action.payload?.id
      if (!nextId) return state
      if (state.instrumentId != null && String(state.instrumentId) === String(nextId)) {
        return state
      }
      return { conditions: [], instrumentId: nextId, needsHydration: true }
    }
    case RESET_INSTRUMENT:
      return { conditions: [] }
    case CLEAR_INSTRUMENT_TRIGGERS:
      return {
        conditions: [],
        instrumentId: state.instrumentId,
        needsHydration: action.needsHydration === true,
      }
    case ADD_INSTRUMENT_TRIGGER: {
      newState.conditions.push(action.trigger)
      newState.needsHydration = false
      return newState
    }
    case DELETE_INSTRUMENT_TRIGGER: {
      const { conditions } = newState
      const newConditionsArr = [...conditions]
      newConditionsArr.splice(action.index, 1)
      newState.conditions = newConditionsArr
      newState.needsHydration = false
      return newState
    }
    case UPDATE_INSTRUMENT_TRIGGER:
      return {
        ...changeTrigger(
          newState,
          { key: action.key, value: action.value, key2: action.key2, value2: action.value2 },
          action.index,
          action.isRootTrigger,
        ),
        needsHydration: false,
      }

    case UPDATE_INSTRUMENT_ACTION:
      return {
        ...changeAction(
          newState,
          { key: action.key, value: action.value, key2: action.key2, value2: action.value2, score: action.score },
          action.index,
        ),
        needsHydration: false,
      }
    case CHANGE_INSTRUMENT_TRIGGER_TYPE: {
      const { index, instrumentId, conditionId, newType, virtualVisitsEnabled, scoreParams } = action
      const params = {
        state: newState,
        newType,
        conditionId,
        instrumentId,
        index,
        virtualVisitsEnabled,
        scoreParams,
      }
      return { ..._changeInstrumentTriggerType(params), needsHydration: false }
    }
    case SET_INSTRUMENT_TRIGGERS: {
      const next = { conditions: action.triggers, needsHydration: false }
      if (state.instrumentId != null) next.instrumentId = state.instrumentId
      return next
    }
    case ADD_DIARY_NOTIFICATION_TRIGGER: {
      newState.conditions.unshift(action.trigger)
      newState.needsHydration = false
      return newState
    }
    case UPDATE_DIARY_NOTIFICATION_TRIGGER: {
      const { deploy, conditionId, instrumentId, recurring } = action
      const newDiaryTriggerAction = generateUpdatedDiaryTriggerAction({ conditionId, deploy, instrumentId, recurring })
      newState.conditions[0] = newDiaryTriggerAction
      newState.needsHydration = false
      return newState
    }
    default:
      return state
  }
}

const conditionsToDelete = (state = [], action) => {
  const newState = [...state]
  switch (action.type) {
    case DELETE_INSTRUMENT_TRIGGER:
      if (action.conditionId) newState.push(action.conditionId)
      return newState
    case CLEAR_INSTRUMENT_TRIGGERS:
    case CLEAR_INSTRUMENT_CONDITIONS_TO_DELETE:
      return []
    default:
      return state
  }
}

export const instrument = (state = _getDefaultInstrument(), action) => {
  const newState = { ...state }
  switch (action.type) {
    case SET_INSTRUMENT: {
      const instrument = addInstrumentPermissions(action.payload) || _getDefaultInstrument()
      if (instrument.metadata == null) {
        instrument.metadata = _getDefaultMetadata(instrument.type)
      }
      // Guard: editor expects a single schedule object (multi-schedule list lives in confirmedSchedules)
      if (Array.isArray(instrument.metadata.schedule)) {
        const { activeSchedule } = hydrateSchedulesFromMetadata(instrument.metadata.schedule)
        instrument.metadata.schedule = activeSchedule
      } else if (instrument.metadata.schedule) {
        instrument.metadata.schedule = ensureScheduleIds(instrument.metadata.schedule)[0]
      }
      return instrument
    }
    case RESET_INSTRUMENT:
      return _getDefaultInstrument(action.instrumentType)
    case RESET_SCHEDULE:
      newState.metadata = { ...newState.metadata }
      newState.metadata.schedule = createBlankSchedule(newState.type)
      if (INSTRUMENT_TYPES_WITH_SCHEDULE_PLATFORM.includes(newState.type)) {
        newState.metadata.schedule.platform_type = SCHEDULE_PLATFORM_TYPE.all
      }
      return newState
    case START_NEW_SCHEDULE: {
      newState.metadata = { ...newState.metadata }
      newState.metadata.schedule = createBlankSchedule(action.instrumentType || newState.type)
      return newState
    }
    case LOAD_SCHEDULE_FOR_EDIT: {
      // active schedule body is applied via confirmedSchedules reducer coordination in the action creator path;
      // this case is a no-op on instrument unless payload includes schedule
      if (action.schedule) {
        newState.metadata = { ...newState.metadata }
        newState.metadata.schedule = cloneSchedule(action.schedule)
      }
      return newState
    }
    case DELETE_CONFIRMED_SCHEDULE: {
      // Keep editor schedule in sync with remaining confirmed list so a later
      // Schedule Instrument save cannot re-append the surgically deleted schedule.
      const remaining = action.remainingSchedules
      if (Array.isArray(remaining) && remaining.length > 0) {
        newState.metadata = { ...newState.metadata }
        newState.metadata.schedule = cloneSchedule(remaining[0])
      }
      return newState
    }
    case COMMIT_CURRENT_SCHEDULE: {
      // Ensure the editing schedule has an id and initial version before commit.
      if (newState.metadata?.schedule) {
        newState.metadata = { ...newState.metadata }
        newState.metadata.schedule = ensureScheduleIds(newState.metadata.schedule)[0]
      }
      return newState
    }
    case UPDATE_INSTRUMENT_TITLE:
      newState.title = action.title
      return newState
    case UPDATE_INSTRUMENT_DISPLAY_LOCATION:
      newState.metadata = { ...(newState.metadata || {}) }
      newState.display_location = action.displayLocation
      newState.metadata.display_location = action.displayLocation
      newState.metadata.placement = action.displayLocation
      return newState
    case UPDATE_ARTICLE_URL:
      newState.url = action.url
      return newState
    case UPDATE_SCHEDULE: {
      newState.metadata = { ...newState.metadata }
      newState.metadata.schedule = { ...newState.metadata.schedule }
      if (action.obj === null) {
        delete newState.metadata.schedule[action.key]
      } else {
        newState.metadata.schedule[action.key] = action.obj
        if (action.key === 'cohort' && AUDIENCE_TYPE_VALUES.includes(action.obj?.type)) {
          newState.metadata.schedule.audience_type = action.obj.type
        }
      }
      return newState
    }
    case UPDATE_SCHEDULE_FIELD: {
      newState.metadata = { ...newState.metadata }
      newState.metadata.schedule = { ...newState.metadata.schedule }
      newState.metadata.schedule[action.key] = { ...state.metadata.schedule[action.key] }
      newState.metadata.schedule[action.key][action.field] = action.value
      if (action.key === 'cohort' && action.field === 'type' && AUDIENCE_TYPE_VALUES.includes(action.value)) {
        newState.metadata.schedule.audience_type = action.value
      }
      return newState
    }
    case DELETE_SCHEDULE_FIELD: {
      newState.metadata = { ...newState.metadata }
      newState.metadata.schedule = { ...newState.metadata.schedule }
      delete newState.metadata.schedule[action.field]
      return newState
    }
    case REMOVE_CHAIN_DEPLOYMENT_INFO: {
      newState.metadata = { ...newState.metadata }
      newState.metadata.schedule = { ...newState.metadata.schedule }
      delete newState.metadata.schedule.chain_deployment_info
      return newState
    }
    case UPDATE_VISIBILITY:
      newState.metadata = { ...newState.metadata }
      if (action.onSchedule) {
        newState.metadata.schedule = { ...newState.metadata.schedule }
        if (action.key === 'visibilityRanges' && action.value === null) {
          delete newState.metadata.schedule.visibilityRanges
        } else {
          newState.metadata.schedule[action.key] = action.value
        }
        return newState
      }
      if (action.key === 'visibilityRanges' && action.value === null) {
        delete newState.metadata.visibilityRanges
      } else {
        newState.metadata[action.key] = action.value
      }
      return newState
    case ADD_VISIBILITY_RANGE:
      newState.metadata = { ...newState.metadata }
      if (action.onSchedule) {
        newState.metadata.schedule = { ...newState.metadata.schedule }
        newState.metadata.schedule.visibilityRanges = newState.metadata.schedule.visibilityRanges
          ? newState.metadata.schedule.visibilityRanges.slice()
          : []
        const scheduleDefaultStart = moment()
          .hours(4)
          .startOf('hour')
          .toISOString()
        const scheduleDefaultEnd = moment()
          .hours(16)
          .startOf('hour')
          .toISOString()
        newState.metadata.schedule.visibilityRanges.push({
          start: scheduleDefaultStart,
          end: scheduleDefaultEnd,
        })
        return newState
      }
      newState.metadata.visibilityRanges = newState.metadata.visibilityRanges
        ? newState.metadata.visibilityRanges.slice()
        : []
      const defaultStart = moment()
        .hours(4)
        .startOf('hour')
        .toISOString()
      const defaultEnd = moment()
        .hours(16)
        .startOf('hour')
        .toISOString()
      newState.metadata.visibilityRanges.push({ start: defaultStart, end: defaultEnd })
      return newState
    case UPDATE_VISIBILITY_RANGE:
      newState.metadata = { ...newState.metadata }
      if (action.onSchedule) {
        newState.metadata.schedule = { ...newState.metadata.schedule }
        newState.metadata.schedule.visibilityRanges = newState.metadata.schedule.visibilityRanges.slice()
        // GOLD-11299: Handle null values from TimePicker (e.g., when field is cleared or invalid)
        newState.metadata.schedule.visibilityRanges[action.idx][action.key] = action.value
          ? action.value.startOf('minute').toISOString()
          : null
        return newState
      }
      newState.metadata.visibilityRanges = newState.metadata.visibilityRanges.slice()
      // GOLD-11299: Handle null values from TimePicker (e.g., when field is cleared or invalid)
      newState.metadata.visibilityRanges[action.idx][action.key] = action.value
        ? action.value.startOf('minute').toISOString()
        : null
      return newState
    case DELETE_METADATA_FIELD:
      newState.metadata = { ...newState.metadata }
      delete newState.metadata[action.field]
      return newState
    case UPDATE_METADATA_FIELD:
      newState.metadata = { ...(newState.metadata || {}) }
      newState.metadata[action.field] = action.value
      return newState
    case UPDATE_GEOFENCE_ENABLED:
      newState.is_geofencing_enabled = action.value
      return newState
    case UPDATE_INSTRUMENT_ROLES:
      newState.instrument_roles = action.instrumentRoles
      return newState
    // Do not splice metadata.conditions here. Unsaved deletes live in
    // instrumentTriggers / conditionsToDelete until Schedule Instrument save.
    case DELETE_INSTRUMENT_TRIGGER:
      return newState
    case UPDATE_PREVALIDATED_ERRORS: {
      newState.metadata.schedule.prevalErrors = action.prevalErrors
      return newState
    }
    case CLEAR_PREVALIDATED_ERROR: {
      const { prevalErrors } = newState.metadata.schedule
      if (prevalErrors) {
        delete prevalErrors[action.errorKey]
        const hasPrevalErrors = Object.keys(prevalErrors).length > 0
        if (!hasPrevalErrors) delete newState.metadata.schedule.prevalErrors
      }
      return newState
    }
    default:
      return state
  }
}

const userRoles = (state = [], action) => {
  switch (action.type) {
    case SET_CLINRO_ROLES: {
      return action.roles
    }
    default:
      return state
  }
}

const visitTemplates = (state = [], action) => {
  switch (action.type) {
    case SET_VISIT_TEMPLATES:
      return action.visits
    default:
      return state
  }
}

const instrumentAdvancedOptions = (state = {}, action) => {
  switch (action.type) {
    case SET_ADVANCED_OPTIONS:
      return action.value
    case RESET_ADVANCED_OPTIONS:
      return {}
    default:
      return state
  }
}

const instrumentUnificationEnabled = (state = null, action) => {
  switch (action.type) {
    case SET_INSTRUMENT_UNIFICATION_ENABLED:
      return action.value
    case RESET_INSTRUMENT_UNIFICATION_ENABLED:
      return {}
    default:
      return state
  }
}

const confirmedSchedules = (state = [], action) => {
  switch (action.type) {
    case SET_CONFIRMED_SCHEDULES:
      return ensureScheduleIds(action.schedules || [])
    case COMMIT_CURRENT_SCHEDULE:
      // Handled via setConfirmedSchedules from validateThenReviewSchedule; keep state
      return state
    case DELETE_CONFIRMED_SCHEDULE: {
      if (state.length <= 1) return state
      return state.filter((_, i) => i !== action.index)
    }
    case RESET_INSTRUMENT:
      return []
    default:
      return state
  }
}

const persistedSchedules = (state = [], action) => {
  switch (action.type) {
    case SET_PERSISTED_SCHEDULES:
      return action.schedules || []
    case RESET_INSTRUMENT:
      return []
    default:
      return state
  }
}

const activeScheduleIndex = (state = null, action) => {
  switch (action.type) {
    case SET_ACTIVE_SCHEDULE_INDEX:
      return action.index
    case START_NEW_SCHEDULE:
      return null
    case LOAD_SCHEDULE_FOR_EDIT:
      return action.index
    case DELETE_CONFIRMED_SCHEDULE: {
      if (state == null) return state
      if (action.index === state) return null
      if (action.index < state) return state - 1
      return state
    }
    case RESET_INSTRUMENT:
      return null
    default:
      return state
  }
}

//
// EXPORTS
//

export const instrumentActions = {
  addInstrumentTrigger,
  addDiaryNotificationTrigger,
  changeTriggerType,
  clearInstrumentTriggers,
  deleteInstrumentTrigger,
  onFetchInstrument,
  onFetchInstrumentEvents,
  onSave,
  updateDiaryNotificationTrigger,
  updateGeofenceEnabled,
  updateInstrumentAction,
  updateInstrumentRoles,
  updateInstrumentTrigger,
  handleDateFilterError,
  setInstrumentUnificationEnabled,
  resetInstrumentUnificationEnabled,
  saveInstrumentSitesForPromotion,
}

export const metadataActions = {
  deleteMetadataField,
  updateMetadataField,
  updateInstrumentTitle,
  updateInstrumentDisplayLocation,
  onSave,
}

export const schedulerActions = {
  addVisibilityRange,
  clearInstrumentTriggers,
  deployInstrument: validateThenDeploy,
  deployConfirmedSchedules,
  reviewSchedule: validateThenReviewSchedule,
  removeChainDeploymentInfo,
  resetSchedule,
  setConfirmedSchedules,
  setActiveScheduleIndex,
  commitCurrentSchedule,
  deleteConfirmedSchedule,
  startNewSchedule,
  loadScheduleForEdit,
  updateCohort: obj => updateSchedule('cohort', obj),
  updateCohortField: (field, value, keyPath) => updateScheduleField('cohort', field, value, keyPath),
  updateChainDeployInfo: obj => updateSchedule('chain_deployment_info', obj),
  updateChainDeployInfoField: (field, value, keyPath) =>
    updateScheduleField('chain_deployment_info', field, value, keyPath),
  updateDeploy: obj => updateSchedule('deploy', obj),
  updateDeployField: (field, value, keyPath) => updateScheduleField('deploy', field, value, keyPath),
  updateExpire: obj => updateSchedule('expire', obj),
  updateExpireField: (field, value, keyPath) => updateScheduleField('expire', field, value, keyPath),
  updateRecurring: obj => updateSchedule('recurring', obj),
  updateRecurringField: (field, value, keyPath) => updateScheduleField('recurring', field, value, keyPath),
  updateTimeoutWindow: obj => updateSchedule('timeout_window', obj),
  updateTimeoutWindowField: (field, value, keyPath) => updateScheduleField('timeout_window', field, value, keyPath),
  updateScheduleKey: (key, obj) => updateSchedule(key, obj),
  updateScheduleKeyField: (key, field, value, keyPath) => updateScheduleField(key, field, value, keyPath),
  deleteMetadataKey: (key, field) => deleteMetadataKey(key, field),
  updateSchedule,
  updatePrevalidatedErrors,
  clearPrevalidatedError,
  updateVisibility,
  updateVisibilityRange,
  setAdvancedOptionsToStore,
  resetInstrumentAdvancedOptions,
}

export default combineReducers({
  conditionsToDelete,
  instrument,
  _instrument,
  instrumentEvents,
  instrumentTriggers,
  errors,
  deployedAttempted,
  isEdited,
  userRoles,
  visitTemplates,
  instrumentAdvancedOptions,
  instrumentUnificationEnabled,
  confirmedSchedules,
  persistedSchedules,
  activeScheduleIndex,
})